'use strict';
var vendorApp = angular.module('vendorApp', ['ngMessages', 'chart.js', 'daterangepicker', 'configService', 'sharedServices', 'ui.router', "ui.bootstrap", 'vendorServices', 'sharedFilters', 'ngFileUpload', 'ngDialog', 'rzModule', 'ui.event', 'ngSanitize', '720kb.tooltips', 'ngToast', 'angular-sortable-view', 'updateMeta']);
vendorApp.run(function ($rootScope, $state, config) {
  if ((window.location.href).indexOf('/bookingsDetail/') == -1) {
    if (localStorage.getItem('vendor_logged_in') != 'true') {
      window.location.href = config.domain;
    }
  }
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    $state.go('error');
    $rootScope.hasfeedError = true;
  });

  $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
    window.scrollTo(0, 0);
  });
})

vendorApp.config(function ($interpolateProvider, $stateProvider, $urlRouterProvider, $httpProvider, config, EncryptedLocalStorageProvider, ChartJsProvider, $locationProvider) {
  config.vtoken = localStorage.getItem('vtoken');
  // Configure all charts
  ChartJsProvider.setOptions({
    colours: ['#D81F5B', '#09bb5d', '#f5a623'],
  });
  // Configure all line charts
  ChartJsProvider.setOptions('Line', {
    datasetFill: false
  });
  $httpProvider.useApplyAsync(true);
  $urlRouterProvider.otherwise('/vendor/feeds/leads');
  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('!');
  if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
      'use strict';
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }
  $urlRouterProvider.rule(function ($injector, $location) {
    var path = $location.absUrl();
    if (path.includes('#')) {
      var currentUrl = $location.url();
      var urlAfterRemovingHash = currentUrl.replace(/#/g, '').replace('%2F', '').replace('%3F', '?');
      $location.url(urlAfterRemovingHash);
    }
  });
  $stateProvider.state('main', {
    templateUrl: '../../html/vendorFeedMain.html?v=1.0.4',
    controller: 'duperController',
    abstract: true,
    reloadOnSearch: false,
    resolve: {
      'vendorData': ['vendorDashboard', function (vendorDashboard) {
        return vendorDashboard(config.vtoken);
      }]
    },
  }).state('main.leads', {
    url: '/vendor/feeds/leads?id={vendorId}',
    templateUrl: "../../html/vendorLeads.html?v=1.0.9",
    controller: 'LeadsController',
  }).state('main.information', {
    url: '/vendor/feeds/?id={vendorId}',
    templateUrl: "../../html/vendorInfo.html",
    reloadOnSearch: false,
    controller: 'informationController',
  }).state('main.menu', {
    url: '/vendor/feeds/menu?id={vendorId}',
    templateUrl: "../../html/vendorMenu.html",
    controller: 'MenuController',
  }).state('main.banquets', {
    url: '/vendor/feeds/banquets?id={vendorId}',
    templateUrl: "../../html/vendorBanquets.html",
    controller: 'banquetsController',
  }).state('main.albums', {
    url: '/vendor/feeds/albums?id={vendorId}',
    templateUrl: "../../html/albumInfo.html?v=1.0.1",
    controller: 'albumController',
  }).state('main.statistics', {
    url: '/vendor/feeds/statistics?id={vendorId}',
    templateUrl: "../../html/statistics.html",
    controller: 'statisticsController',
  }).state('main.reviews', {
    url: '/vendor/feeds/reviews?id={vendorId}',
    templateUrl: "../../html/vendorReview.html",
    controller: 'reviewController',
  }).state('main.inbox', {
    url: '/vendor/feeds/inbox?id={vendorId}',
    templateUrl: "../../html/vendorInbox.html",
    controller: 'vendorInboxController',
  }).state('main.membership', {
    url: '/vendor/feeds/membership?id={vendorId}',
    templateUrl: "../../html/membership.html?v=1.0.3",
    controller: 'membController',
  }).state('main.membPlans', {
    url: '/vendor/feeds/membership/plans?id={vendorId}&memb={membId}',
    templateUrl: "../../html/membershipPlans.html",
    controller: 'membPlansController',
  }).state('main.membChosen', {
    url: '/vendor/feeds/membership/plan-selected?id={vendorId}&plan={planId}',
    templateUrl: "../../html/membershipChosen.html?v=1.0.1",
    controller: 'membChosenController',
  }).state('main.membResponse', {
    url: '/vendor/feeds/membership/response?id={vendorId}&orderId={Id}',
    templateUrl: '../../html/membershipResponse.html',
    controller: 'membResponseController',
  }).state('main.location', {
    url: '/vendor/feeds/location?id={vendorId}',
    templateUrl: "../../html/vendorLocation.html",
    controller: 'locationController',
  }).state('main.pricing', {
    url: '/vendor/feeds/pricing?id={vendorId}',
    templateUrl: "../../html/vendorPricing.html?v=1.0.3",
    controller: 'pricingController',
    css: '../../css/vendorTransaction.css',
  }).state('main.image', {
    url: '/vendor/feeds/image/:section/:Pid?id={vendorId}',
    templateUrl: "../../html/albumImage.html?v=1.1",
    controller: 'albumImageController',
  }).state('main.message', {
    url: '/vendor/feeds/message/:threadId?id={vendorId}',
    templateUrl: "../../html/inboxMessage.html",
    controller: 'inboxMessageController',
  }).state('main.bookings', {
    url: '/vendor/feeds/bookings/?id={vendorId}',
    templateUrl: "../../html/vendorBooking.html",
    controller: 'bookingController',
  }).state('main.widgets', {
    url: '/vendor/feeds/widgets/?id={vendorId}',
    templateUrl: "../../html/vendorWidgets.html",
    controller: 'widgetController',
  }).state('main.bookingsDetail', {
    url: '/vendor/feeds/bookingsDetail/:detailId?booking_hash={bookingHash}&is_new={isNew}&id={vendorId}',
    templateUrl: "../../html/vendorBookingDetail.html",
    controller: 'bookingDetailController',
  }).state('error', {
    url: "/vendor/feeds/error",
    templateUrl: '../../html/error-vendor.html',
    controller: 'errorController',
    onEnter: function ($rootScope, $state) {
      if (!$rootScope.hasfeedError) {
        $state.go('main.information');
      }
    }
  });
  $interpolateProvider.startSymbol('{[');
  $interpolateProvider.endSymbol(']}');
  $httpProvider.useApplyAsync(true);
  $httpProvider.interceptors.push('APIInterceptor');
});
vendorApp.controller('duperController', ['$scope', '$timeout', '$rootScope', '$sce', '$stateParams', '$state', '$location', '$interval', '$window', 'vendorData', 'config', 'saveCategory', 'imageOrder', 'ngDialog', 'albumOrder', 'vendorGst', 'requestCalender', function ($scope, $timeout, $rootScope, $sce, $stateParams, $state, $location, $interval, $window, vendorData, config, saveCategory, imageOrder, ngDialog, albumOrder, vendorGst, requestCalender) {
  $scope.statesList = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Orissa",
    "Punjab",
    "Puducherry",
    "Rajasthan",
    "Sikkim",
    "Telangana",
    "Tamil Nadu",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
  ];

  if (vendorData.data.data) {
    var popupFlag = vendorData.data.data.business_detail_status;
    if (typeof popupFlag == 'undefined' || popupFlag == '0') {
      $("#gst-popup").modal('show');
    }
    $scope.showGstForm = true;
    $scope.showGstForm2 = false;
    $scope.showGstForm3 = false;
    $scope.gstSubmit = function () {
      // console.log($scope.gst);
      vendorGst(config.vtoken, $scope.gst).then(function (response) {
        $scope.showGstForm = false;
        $scope.showGstForm2 = true;
        $timeout(function () {
          $("#gst-popup").modal('hide');
        }, 2000);
        // console.log(response);
      })
        .catch(function (err) {
          $scope.showGstForm = false;
          $scope.showGstForm3 = true;
          // console.log(err);
          $timeout(function () {
            $("#gst-popup").modal('hide');
          }, 2000);
        });
    }
    $scope.ogImage = vendorData.data.data.original_pic_url;
    $scope.vendorData = vendorData.data.data;
    $scope.vendorData.progressMessage = angular.copy($scope.vendorData.progressbar_message);
    if ($scope.vendorData.role[0] == 'ROLE_BRAND_VENDOR') {
      $scope.vendorId = [];
      $rootScope.brandLead = true;
      for (var i = 0; i < $scope.vendorData.vendors.length; i++) {
        $scope.vendorId.push($scope.vendorData.vendors[i].id);
      }
      $scope.vendorArr = angular.copy($scope.vendorId);
      // console.log($scope.vendorArr);
      $scope.vendorId = $scope.vendorId.join();
      $scope.originalVendorIds = angular.copy($scope.vendorId);
    } else {
      $rootScope.brandLead = false;
      $scope.vendorId = $scope.vendorData.vendor_id;
    }
    // console.log($scope.vendorId);
    $scope.inboxUnread = $scope.vendorData.unread_count;
    $scope.vendorProfileSlug = $scope.vendorData.slug;
    $scope.sharePic = $scope.vendorData.original_pic_url;
    $scope.vendorName = $scope.vendorData.name;
    $scope.storeEnable = $scope.vendorData.store_enabled;
    $scope.infoTab = $scope.storeEnable ? false : true;
    $scope.typeTest = '';
    $scope.imageData = {};
    $scope.imageData.hasUnsavedChanges = false;
    $scope.albumInfo = {};
    $scope.albumInfo.hasUnsavedChanges = false;
    $stateParams['id'] = $scope.vendorId;
    $state.params['id'] = $scope.vendorId;
    $location.search('id', $scope.vendorId);
    $scope.S3_URL = config.S3_URL;
    $scope.vendorData.hasBaseCity = false;
    if ($scope.vendorData.city) {
      $scope.vendorData.hasBaseCity = true;
    }
    // var intervalPrmse;
    // // code to check in intervals if the user is logged in
    // var startInterval = function() {
    //     intervalPrmse = $interval(function() {
    //         if (!localStorage.getItem('vendor_logged_in')) {
    //             $window.location.href = config.domain;
    //         }
    //     }, 6000)
    // }
    // startInterval();
    $timeout(function () {
      var $vid = $('.audio-recording').find('audio');
      //console.log($vid.get(23));
      for (var i = 0; i < $vid.length; i++) {
        $vid.get(i).onplay = function () {
          var that = this;
          $.each($('audio'), function () {
            if (that != this) {
              this.pause();
            }
          });
        };
      }
    }, 1000);
  }

  $scope.redirectToAlbums = function () {
    $("#new-vendor-popup").modal('hide');
    $state.go('main.albums', { 'id': $scope.vendorId }, { reload: true });
  }
  $scope.redirectToProjects = function(){
    location.assign('/vendor-dashboard/projects');
  }

  $scope.share_promptA = function (slug, name) {
    share_promptV(slug, name, $scope.ogImage);
  }

  $scope.sorted = function ($item, $indexTo, type) {
    $('.add-new-image-block').addClass('hide');
    $('.edit-del').addClass('hide');
    $scope.imageData.hasUnsavedChanges = true;
    $scope.albumInfo.hasUnsavedChanges = true;
    $('.r-save-inside').removeClass('hide');
    if (!$('.inbox-message-text').length) {
      $('.r-save-inside').addClass('top-35');
    }
    if (!$('.r-save-inside').isOnScreenVertical()) {
      $('.r-save-outside').removeClass('hide').addClass('w-100');
      if ($('.left-fb').length && !$('.left-fb').isOnScreenVertical()) {
        $('.save-changes-div').addClass('fixedSaveChanges');
      } else {
        $('.save-changes-div').removeClass('fixedSaveChanges');
      }
    }
    if (type == 'image') {
      $scope.ArraytoChange = $scope.imageData.imageInfo.images.splice($indexTo);
      $scope.typeTest = 'image';
      $scope.imageData.imageInfo.images = $scope.imageData.imageInfo.images.concat($scope.ArraytoChange);
      $scope.imageData.imageInfo.images.forEach(function (x, i) {
        x.image_order = i + 1;
      });
      // $scope.imageData.imageInfo.images = $scope.imageData.imageInfo.images.map(function(data) {
      //   data.image_order = $scope.ArraytoChange.length - $indexTo;
      //   $indexTo--;
      //   return data;
      // });
    } else if (type == 'album') {
      $scope.typeTest = 'album'
      $scope.ArraytoChange = $scope.albumInfo.albums.splice($indexTo);
      $scope.ArraytoChange = $scope.ArraytoChange.map(function (data) {
        data.project_order = $indexTo;
        $indexTo++;
        return data;
      });
      $scope.albumInfo.albums = $scope.albumInfo.albums.concat($scope.ArraytoChange);
    }
  }

  $scope.toggleDiv = function (e) {
    var $that = $(e.target);
    $that.closest('a').next('ul').toggleClass('hide');
    if ($that.closest('a').find('.fa-angle-up').hasClass('hide')) {
      $that.closest('a').find('.fa-angle-up').removeClass('hide');
      $that.closest('a').find('.fa-angle-down').addClass('hide');
    } else {
      $that.closest('a').find('.fa-angle-up').addClass('hide');
      $that.closest('a').find('.fa-angle-down').removeClass('hide');
    }
  }

  $scope.checkStore = function (e, id) {
    var $that = $(e.target);
    if ($that.closest('label').find('.checkbox-d').hasClass('checkbox-u')) {
      $that.closest('label').find('.checkbox-d').removeClass('checkbox-u').addClass('checkbox-c');
      var msg = { 'id': id, 'checked': true };
      $rootScope.$emit('brand_filter', msg);
    } else {
      $that.closest('label').find('.checkbox-d').addClass('checkbox-u').removeClass('checkbox-c');
      var msg = { 'id': id, 'checked': false };
      $rootScope.$emit('brand_filter', msg);
    }
  }

  $scope.discardSortChanges = function () {
    $('.save-changes').removeClass('save-animate');
    $scope.imageData.hasUnsavedChanges = false;
    $scope.albumInfo.hasUnsavedChanges = false;
    $('.add-new-image-block').removeClass('hide');
    $('.edit-del').removeClass('hide');
    $('.save-changes').addClass('hide');

  }

  $scope.goToState = function (state) {
    var arr = [];
    arr = state.split('(');
    $scope.imageData.hasUnsavedChanges = false;
    $scope.albumInfo.hasUnsavedChanges = false;
    $state.go(arr[0], { 'id': $scope.vendorId });
  }

  $scope.showChangePrompt = function (state) {
    if (!$scope.imageData.hasUnsavedChanges) {
      return;
    } else if (!$scope.imageData.hasUnsavedChanges) {
      return;
    }
    $scope.selectedId = [state];
    ngDialog.open({
      template: 'unsavedTemplateId',
      scope: $scope,
      data: $scope.selectedId,
    })
  }
	
if(window.location.host.includes('admin')) {
	if (document.getElementById('inbox-link-vd')) document.getElementById('inbox-link-vd').style.display = 'none';
}

  $scope.goToNewDashboard = function (path) {
    console.log('goToNewDashboard', path); // intentional log - DKA
    location.href = location.origin + "/vendor-dashboard/" + path;
  }

  $scope.saveSortChanges = function (type) {
    if (type == 'image' || $scope.typeTest == 'image') {
      imageOrder(config.vtoken, $scope.imageData.imageInfo.images).success(function (data) {
        $('.save-changes').removeClass('save-animate');
        $scope.imageData.hasUnsavedChanges = false;
        $('.add-new-image-block').removeClass('hide');
        $scope.typeTest = ''
        $('.edit-del').removeClass('hide');
        $('.save-changes').addClass('hide');
      })
    } else if (type == 'album' || $scope.typeTest == 'album') {
      albumOrder(config.vtoken, $scope.albumInfo.albums).success(function (data) {
        $('.save-changes').removeClass('save-animate');
        $scope.albumInfo.hasUnsavedChanges = false;
        $('.add-new-image-block').removeClass('hide');
        $('.edit-del').removeClass('hide');
        $scope.typeTest = ''
        $('.save-changes').addClass('hide');
      })
    }
  }

  $scope.requestCalenderNow = function () {
    $scope.calenderRequested = true;
    requestCalender(config.vtoken).then(function () {
      // Do nothing
    }, function () {
      $scope.calenderRequested = false;
    });
  }

  $scope.sortingStarted = function ($helper, e) {
    var parentWin = parent.window;
    var $userScreenHeight = $(parentWin).height();

    // console.log(parentWin, $pxFromTop, $userScreenHeight);

    $(document).mousemove(function (ev) {
      var $pxFromTop = $(parentWin).scrollTop();
      // console.log(ev.pageY, $(parentWin).scrollTop());
      if (ev.which == 1) {
        // console.log(ev.pageY);
        // console.log(ev.pageY, $userScreenHeight, $pxFromTop);
        if (($userScreenHeight + $pxFromTop) - ev.pageY < 100) {
          parentWin.scrollBy(0, ($userScreenHeight / 150));

          // if (ev.pageY > (($userScreenHeight + $pxFromTop) / 1.25)) {
          //   if ($pxFromTop < ($userScreenHeight * 3.2)) {
          //     console.log('therere');
          //     parentWin.scrollBy(0, ($userScreenHeight / 150));
          //   }
          // }
          // else if (ev.pageY < (($userScreenHeight + $pxFromTop) * .75)) {
          //   console.log('hererere');
          //   parentWin.scrollBy(0, -($userScreenHeight / 150));
          // }

        }
        else if (ev.pageY - $pxFromTop < 100) {
          parentWin.scrollBy(0, -($userScreenHeight / 150));
        }
      }
    });
    //console.log($($helper));
    //console.log($event.target);
    // console.log($($helper).css('cursor','pointer'));
    // $($helper).css('color','blue !important');
  }
  $scope.convertToTimestamp = function (date) {
    var match = date.toString().match(/^(\d+)-(\d+)-(\d+) (\d+)\:(\d+)\:(\d+)$/)
    var newDate = new Date(match[1], match[2] - 1, match[3], match[4], match[5], match[6]);
    newDate = (newDate.getTime() / 1000);
    return newDate;
  }
}]);
vendorApp.controller('errorController', ['$scope', 'config', function ($scope, config) {
  $scope.S3_URL = config.S3_URL
}]);
vendorApp.controller('informationController', ['$scope', '$state', '$timeout', 'updateVendorInfo', 'config', 'vendorData', 'getStoreInfo', 'addStoreInfo', 'editStoreInfo', 'vendorInfo', 'sendOtpEmail', 'addSecondaryEmail', 'addPrimaryEmail', 'priceLockAddRequest', function ($scope, $state, $timeout, updateVendorInfo, config, vendorData, getStoreInfo, addStoreInfo, editStoreInfo, vendorInfo, sendOtpEmail, addSecondaryEmail, addPrimaryEmail, priceLockAddRequest) {
  $scope.ogImage = vendorData.data.data.original_pic_url;
    $scope.countryCodeList = [ { "name": "Afghanistan", "dial_code": "+93", "code": "AF" }, { "name": "Aland Islands", "dial_code": "+358", "code": "AX" }, { "name": "Albania", "dial_code": "+355", "code": "AL" }, { "name": "Algeria", "dial_code": "+213", "code": "DZ" }, { "name": "AmericanSamoa", "dial_code": "+1684", "code": "AS" }, { "name": "Andorra", "dial_code": "+376", "code": "AD" }, { "name": "Angola", "dial_code": "+244", "code": "AO" }, { "name": "Anguilla", "dial_code": "+1264", "code": "AI" }, { "name": "Antarctica", "dial_code": "+672", "code": "AQ" }, { "name": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG" }, { "name": "Argentina", "dial_code": "+54", "code": "AR" }, { "name": "Armenia", "dial_code": "+374", "code": "AM" }, { "name": "Aruba", "dial_code": "+297", "code": "AW" }, { "name": "Australia", "dial_code": "+61", "code": "AU" }, { "name": "Austria", "dial_code": "+43", "code": "AT" }, { "name": "Azerbaijan", "dial_code": "+994", "code": "AZ" }, { "name": "Bahamas", "dial_code": "+1242", "code": "BS" }, { "name": "Bahrain", "dial_code": "+973", "code": "BH" }, { "name": "Bangladesh", "dial_code": "+880", "code": "BD" }, { "name": "Barbados", "dial_code": "+1246", "code": "BB" }, { "name": "Belarus", "dial_code": "+375", "code": "BY" }, { "name": "Belgium", "dial_code": "+32", "code": "BE" }, { "name": "Belize", "dial_code": "+501", "code": "BZ" }, { "name": "Benin", "dial_code": "+229", "code": "BJ" }, { "name": "Bermuda", "dial_code": "+1441", "code": "BM" }, { "name": "Bhutan", "dial_code": "+975", "code": "BT" }, { "name": "Bolivia, Plurinational State of bolivia", "dial_code": "+591", "code": "BO" }, { "name": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA" }, { "name": "Botswana", "dial_code": "+267", "code": "BW" }, { "name": "Brazil", "dial_code": "+55", "code": "BR" }, { "name": "British Indian Ocean Territory", "dial_code": "+246", "code": "IO" }, { "name": "Brunei Darussalam", "dial_code": "+673", "code": "BN" }, { "name": "Bulgaria", "dial_code": "+359", "code": "BG" }, { "name": "Burkina Faso", "dial_code": "+226", "code": "BF" }, { "name": "Burundi", "dial_code": "+257", "code": "BI" }, { "name": "Cambodia", "dial_code": "+855", "code": "KH" }, { "name": "Cameroon", "dial_code": "+237", "code": "CM" }, { "name": "Canada", "dial_code": "+1", "code": "CA" }, { "name": "Cape Verde", "dial_code": "+238", "code": "CV" }, { "name": "Cayman Islands", "dial_code": "+ 345", "code": "KY" }, { "name": "Central African Republic", "dial_code": "+236", "code": "CF" }, { "name": "Chad", "dial_code": "+235", "code": "TD" }, { "name": "Chile", "dial_code": "+56", "code": "CL" }, { "name": "China", "dial_code": "+86", "code": "CN" }, { "name": "Christmas Island", "dial_code": "+61", "code": "CX" }, { "name": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC" }, { "name": "Colombia", "dial_code": "+57", "code": "CO" }, { "name": "Comoros", "dial_code": "+269", "code": "KM" }, { "name": "Congo", "dial_code": "+242", "code": "CG" }, { "name": "Congo, The Democratic Republic of the Congo", "dial_code": "+243", "code": "CD" }, { "name": "Cook Islands", "dial_code": "+682", "code": "CK" }, { "name": "Costa Rica", "dial_code": "+506", "code": "CR" }, { "name": "Cote d'Ivoire", "dial_code": "+225", "code": "CI" }, { "name": "Croatia", "dial_code": "+385", "code": "HR" }, { "name": "Cuba", "dial_code": "+53", "code": "CU" }, { "name": "Cyprus", "dial_code": "+357", "code": "CY" }, { "name": "Czech Republic", "dial_code": "+420", "code": "CZ" }, { "name": "Denmark", "dial_code": "+45", "code": "DK" }, { "name": "Djibouti", "dial_code": "+253", "code": "DJ" }, { "name": "Dominica", "dial_code": "+1767", "code": "DM" }, { "name": "Dominican Republic", "dial_code": "+1849", "code": "DO" }, { "name": "Ecuador", "dial_code": "+593", "code": "EC" }, { "name": "Egypt", "dial_code": "+20", "code": "EG" }, { "name": "El Salvador", "dial_code": "+503", "code": "SV" }, { "name": "Equatorial Guinea", "dial_code": "+240", "code": "GQ" }, { "name": "Eritrea", "dial_code": "+291", "code": "ER" }, { "name": "Estonia", "dial_code": "+372", "code": "EE" }, { "name": "Ethiopia", "dial_code": "+251", "code": "ET" }, { "name": "Falkland Islands (Malvinas)", "dial_code": "+500", "code": "FK" }, { "name": "Faroe Islands", "dial_code": "+298", "code": "FO" }, { "name": "Fiji", "dial_code": "+679", "code": "FJ" }, { "name": "Finland", "dial_code": "+358", "code": "FI" }, { "name": "France", "dial_code": "+33", "code": "FR" }, { "name": "French Guiana", "dial_code": "+594", "code": "GF" }, { "name": "French Polynesia", "dial_code": "+689", "code": "PF" }, { "name": "Gabon", "dial_code": "+241", "code": "GA" }, { "name": "Gambia", "dial_code": "+220", "code": "GM" }, { "name": "Georgia", "dial_code": "+995", "code": "GE" }, { "name": "Germany", "dial_code": "+49", "code": "DE" }, { "name": "Ghana", "dial_code": "+233", "code": "GH" }, { "name": "Gibraltar", "dial_code": "+350", "code": "GI" }, { "name": "Greece", "dial_code": "+30", "code": "GR" }, { "name": "Greenland", "dial_code": "+299", "code": "GL" }, { "name": "Grenada", "dial_code": "+1473", "code": "GD" }, { "name": "Guadeloupe", "dial_code": "+590", "code": "GP" }, { "name": "Guam", "dial_code": "+1671", "code": "GU" }, { "name": "Guatemala", "dial_code": "+502", "code": "GT" }, { "name": "Guernsey", "dial_code": "+44", "code": "GG" }, { "name": "Guinea", "dial_code": "+224", "code": "GN" }, { "name": "Guinea-Bissau", "dial_code": "+245", "code": "GW" }, { "name": "Guyana", "dial_code": "+595", "code": "GY" }, { "name": "Haiti", "dial_code": "+509", "code": "HT" }, { "name": "Holy See (Vatican City State)", "dial_code": "+379", "code": "VA" }, { "name": "Honduras", "dial_code": "+504", "code": "HN" }, { "name": "Hong Kong", "dial_code": "+852", "code": "HK" }, { "name": "Hungary", "dial_code": "+36", "code": "HU" }, { "name": "Iceland", "dial_code": "+354", "code": "IS" }, { "name": "India", "dial_code": "+91", "code": "IN" }, { "name": "Indonesia", "dial_code": "+62", "code": "ID" }, { "name": "Iran, Islamic Republic of Persian Gulf", "dial_code": "+98", "code": "IR" }, { "name": "Iraq", "dial_code": "+964", "code": "IQ" }, { "name": "Ireland", "dial_code": "+353", "code": "IE" }, { "name": "Isle of Man", "dial_code": "+44", "code": "IM" }, { "name": "Israel", "dial_code": "+972", "code": "IL" }, { "name": "Italy", "dial_code": "+39", "code": "IT" }, { "name": "Jamaica", "dial_code": "+1876", "code": "JM" }, { "name": "Japan", "dial_code": "+81", "code": "JP" }, { "name": "Jersey", "dial_code": "+44", "code": "JE" }, { "name": "Jordan", "dial_code": "+962", "code": "JO" }, { "name": "Kazakhstan", "dial_code": "+77", "code": "KZ" }, { "name": "Kenya", "dial_code": "+254", "code": "KE" }, { "name": "Kiribati", "dial_code": "+686", "code": "KI" }, { "name": "Korea, Democratic People's Republic of Korea", "dial_code": "+850", "code": "KP" }, { "name": "Korea, Republic of South Korea", "dial_code": "+82", "code": "KR" }, { "name": "Kuwait", "dial_code": "+965", "code": "KW" }, { "name": "Kyrgyzstan", "dial_code": "+996", "code": "KG" }, { "name": "Laos", "dial_code": "+856", "code": "LA" }, { "name": "Latvia", "dial_code": "+371", "code": "LV" }, { "name": "Lebanon", "dial_code": "+961", "code": "LB" }, { "name": "Lesotho", "dial_code": "+266", "code": "LS" }, { "name": "Liberia", "dial_code": "+231", "code": "LR" }, { "name": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY" }, { "name": "Liechtenstein", "dial_code": "+423", "code": "LI" }, { "name": "Lithuania", "dial_code": "+370", "code": "LT" }, { "name": "Luxembourg", "dial_code": "+352", "code": "LU" }, { "name": "Macao", "dial_code": "+853", "code": "MO" }, { "name": "Macedonia", "dial_code": "+389", "code": "MK" }, { "name": "Madagascar", "dial_code": "+261", "code": "MG" }, { "name": "Malawi", "dial_code": "+265", "code": "MW" }, { "name": "Malaysia", "dial_code": "+60", "code": "MY" }, { "name": "Maldives", "dial_code": "+960", "code": "MV" }, { "name": "Mali", "dial_code": "+223", "code": "ML" }, { "name": "Malta", "dial_code": "+356", "code": "MT" }, { "name": "Marshall Islands", "dial_code": "+692", "code": "MH" }, { "name": "Martinique", "dial_code": "+596", "code": "MQ" }, { "name": "Mauritania", "dial_code": "+222", "code": "MR" }, { "name": "Mauritius", "dial_code": "+230", "code": "MU" }, { "name": "Mayotte", "dial_code": "+262", "code": "YT" }, { "name": "Mexico", "dial_code": "+52", "code": "MX" }, { "name": "Micronesia, Federated States of Micronesia", "dial_code": "+691", "code": "FM" }, { "name": "Moldova", "dial_code": "+373", "code": "MD" }, { "name": "Monaco", "dial_code": "+377", "code": "MC" }, { "name": "Mongolia", "dial_code": "+976", "code": "MN" }, { "name": "Montenegro", "dial_code": "+382", "code": "ME" }, { "name": "Montserrat", "dial_code": "+1664", "code": "MS" }, { "name": "Morocco", "dial_code": "+212", "code": "MA" }, { "name": "Mozambique", "dial_code": "+258", "code": "MZ" }, { "name": "Myanmar", "dial_code": "+95", "code": "MM" }, { "name": "Namibia", "dial_code": "+264", "code": "NA" }, { "name": "Nauru", "dial_code": "+674", "code": "NR" }, { "name": "Nepal", "dial_code": "+977", "code": "NP" }, { "name": "Netherlands", "dial_code": "+31", "code": "NL" }, { "name": "Netherlands Antilles", "dial_code": "+599", "code": "AN" }, { "name": "New Caledonia", "dial_code": "+687", "code": "NC" }, { "name": "New Zealand", "dial_code": "+64", "code": "NZ" }, { "name": "Nicaragua", "dial_code": "+505", "code": "NI" }, { "name": "Niger", "dial_code": "+227", "code": "NE" }, { "name": "Nigeria", "dial_code": "+234", "code": "NG" }, { "name": "Niue", "dial_code": "+683", "code": "NU" }, { "name": "Norfolk Island", "dial_code": "+672", "code": "NF" }, { "name": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP" }, { "name": "Norway", "dial_code": "+47", "code": "NO" }, { "name": "Oman", "dial_code": "+968", "code": "OM" }, { "name": "Pakistan", "dial_code": "+92", "code": "PK" }, { "name": "Palau", "dial_code": "+680", "code": "PW" }, { "name": "Palestinian Territory, Occupied", "dial_code": "+970", "code": "PS" }, { "name": "Panama", "dial_code": "+507", "code": "PA" }, { "name": "Papua New Guinea", "dial_code": "+675", "code": "PG" }, { "name": "Paraguay", "dial_code": "+595", "code": "PY" }, { "name": "Peru", "dial_code": "+51", "code": "PE" }, { "name": "Philippines", "dial_code": "+63", "code": "PH" }, { "name": "Pitcairn", "dial_code": "+872", "code": "PN" }, { "name": "Poland", "dial_code": "+48", "code": "PL" }, { "name": "Portugal", "dial_code": "+351", "code": "PT" }, { "name": "Puerto Rico", "dial_code": "+1939", "code": "PR" }, { "name": "Qatar", "dial_code": "+974", "code": "QA" }, { "name": "Romania", "dial_code": "+40", "code": "RO" }, { "name": "Russia", "dial_code": "+7", "code": "RU" }, { "name": "Rwanda", "dial_code": "+250", "code": "RW" }, { "name": "Reunion", "dial_code": "+262", "code": "RE" }, { "name": "Saint Barthelemy", "dial_code": "+590", "code": "BL" }, { "name": "Saint Helena, Ascension and Tristan Da Cunha", "dial_code": "+290", "code": "SH" }, { "name": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN" }, { "name": "Saint Lucia", "dial_code": "+1758", "code": "LC" }, { "name": "Saint Martin", "dial_code": "+590", "code": "MF" }, { "name": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "dial_code": "+1784", "code": "VC" }, { "name": "Samoa", "dial_code": "+685", "code": "WS" }, { "name": "San Marino", "dial_code": "+378", "code": "SM" }, { "name": "Sao Tome and Principe", "dial_code": "+239", "code": "ST" }, { "name": "Saudi Arabia", "dial_code": "+966", "code": "SA" }, { "name": "Senegal", "dial_code": "+221", "code": "SN" }, { "name": "Serbia", "dial_code": "+381", "code": "RS" }, { "name": "Seychelles", "dial_code": "+248", "code": "SC" }, { "name": "Sierra Leone", "dial_code": "+232", "code": "SL" }, { "name": "Singapore", "dial_code": "+65", "code": "SG" }, { "name": "Slovakia", "dial_code": "+421", "code": "SK" }, { "name": "Slovenia", "dial_code": "+386", "code": "SI" }, { "name": "Solomon Islands", "dial_code": "+677", "code": "SB" }, { "name": "Somalia", "dial_code": "+252", "code": "SO" }, { "name": "South Africa", "dial_code": "+27", "code": "ZA" }, { "name": "South Sudan", "dial_code": "+211", "code": "SS" }, { "name": "South Georgia and the South Sandwich Islands", "dial_code": "+500", "code": "GS" }, { "name": "Spain", "dial_code": "+34", "code": "ES" }, { "name": "Sri Lanka", "dial_code": "+94", "code": "LK" }, { "name": "Sudan", "dial_code": "+249", "code": "SD" }, { "name": "Suriname", "dial_code": "+597", "code": "SR" }, { "name": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ" }, { "name": "Swaziland", "dial_code": "+268", "code": "SZ" }, { "name": "Sweden", "dial_code": "+46", "code": "SE" }, { "name": "Switzerland", "dial_code": "+41", "code": "CH" }, { "name": "Syrian Arab Republic", "dial_code": "+963", "code": "SY" }, { "name": "Taiwan", "dial_code": "+886", "code": "TW" }, { "name": "Tajikistan", "dial_code": "+992", "code": "TJ" }, { "name": "Tanzania, United Republic of Tanzania", "dial_code": "+255", "code": "TZ" }, { "name": "Thailand", "dial_code": "+66", "code": "TH" }, { "name": "Timor-Leste", "dial_code": "+670", "code": "TL" }, { "name": "Togo", "dial_code": "+228", "code": "TG" }, { "name": "Tokelau", "dial_code": "+690", "code": "TK" }, { "name": "Tonga", "dial_code": "+676", "code": "TO" }, { "name": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT" }, { "name": "Tunisia", "dial_code": "+216", "code": "TN" }, { "name": "Turkey", "dial_code": "+90", "code": "TR" }, { "name": "Turkmenistan", "dial_code": "+993", "code": "TM" }, { "name": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC" }, { "name": "Tuvalu", "dial_code": "+688", "code": "TV" }, { "name": "Uganda", "dial_code": "+256", "code": "UG" }, { "name": "Ukraine", "dial_code": "+380", "code": "UA" }, { "name": "United Arab Emirates", "dial_code": "+971", "code": "AE" }, { "name": "United Kingdom", "dial_code": "+44", "code": "GB" }, { "name": "United States", "dial_code": "+1", "code": "US" }, { "name": "Uruguay", "dial_code": "+598", "code": "UY" }, { "name": "Uzbekistan", "dial_code": "+998", "code": "UZ" }, { "name": "Vanuatu", "dial_code": "+678", "code": "VU" }, { "name": "Venezuela, Bolivarian Republic of Venezuela", "dial_code": "+58", "code": "VE" }, { "name": "Vietnam", "dial_code": "+84", "code": "VN" }, { "name": "Virgin Islands, British", "dial_code": "+1284", "code": "VG" }, { "name": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI" }, { "name": "Wallis and Futuna", "dial_code": "+681", "code": "WF" }, { "name": "Yemen", "dial_code": "+967", "code": "YE" }, { "name": "Zambia", "dial_code": "+260", "code": "ZM" }, { "name": "Zimbabwe", "dial_code": "+263", "code": "ZW" } ]

  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }

  $scope.setDefault = function (id) {
    $scope.vendorInfo.faq.forEach(function (x) {
      if (x.allow_set_default_price == 1) {
        if (x.id !== id) {
          x.is_default = 0;
        }
      }
    });
  }

  vendorInfo(config.vtoken).success(function (data) {
    $scope.vendorInfo = angular.copy(data.data);
    if ($scope.vendorInfo.category_id == null || typeof $scope.vendorInfo.category_id == 'undefined' || $scope.vendorInfo.category_id == '0' || !$scope.vendorInfo.category_id) {
      mastersApi();
      $('#categoryModal').modal({
        backdrop: 'static',
        keyboard: false
      });
      $('#categoryModal').modal('show');
      return;
    }

    $scope.vendorData.infoForm = {
      contactNumber: $scope.vendorInfo.phone_numbers //[{contactNo:'',type:'1'}]
    };
    if (!$scope.vendorInfo.phone_numbers.length || !$scope.vendorInfo.phone_numbers || $scope.vendorInfo.phone_numbers == null) {
      $scope.vendorData.infoForm.contactNumber.push({
        phone: '',
        is_landline: '0',
        country_code: "+91",
      });
    }

    $scope.vendorData.infoForm.bName = $scope.vendorInfo.name;
    $scope.vendorData.infoForm.vendorStatus = $scope.vendorInfo.vendor_status;
    $scope.vendorData.infoForm.loginID = $scope.vendorInfo.email;
    $scope.vendorData.infoForm.isEmailDisabled = $scope.vendorInfo.email ? 1 : 0;
    $scope.vendorData.infoForm.pName = $scope.vendorInfo.contact_name;
    $scope.vendorData.infoForm.addID = $scope.vendorInfo.contact_email;
    $scope.vendorData.infoForm.web_link = $scope.vendorInfo.websiteLink;
    $scope.vendorData.infoForm.addInfo = $scope.vendorInfo.information;
    $scope.vendorData.infoForm.cities = $scope.vendorInfo.cities;
    $scope.vendorData.infoForm.baseCity = $scope.vendorInfo.city;
    $scope.vendorData.infoForm.facebookLink = $scope.vendorInfo.facebookLink;
    $scope.vendorData.infoForm.vimeoLink = $scope.vendorInfo.vimeoLink;
    $scope.vendorData.infoForm.instaLink = $scope.vendorInfo.instaLink;
    $scope.vendorData.infoForm.category_id = $scope.vendorInfo.category_id;
    $scope.vendorData.infoForm.category_name = $scope.vendorInfo.category_name;
    $scope.addInfo.infoForm.vendor_bio = $scope.vendorInfo.vendor_bio;
    $scope.vendorData.faqForm = {};
    $scope.vendorData.infoForm.faq = [];
    if ($scope.vendorInfo.faq.length) {
      recursionFaq($scope.vendorInfo.faq, $scope.count.val);
    }
    beforeSubmitFlag = 1;
  });
  //$scope.vendorData = vendorData.data.data;
  $scope.storeEnable = $scope.vendorData.store_enabled;
  //var faq = $scope.vendorInfo.faq
  $scope.count = {};
  $scope.count.val = 0;
  $scope.errorObject = {};
  var beforeSubmitFlag = 0;

  setTimeout(function() {  
    var elements = document.getElementsByClassName("req-pr-cha-slider");
    var openPriceChangeModalFifth = function(event) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = this.getAttribute("data-attribute-id");
        angular.element(angular.element('.modal-fifth[data-attribute-id="' + id + '"]')[0]).modal('show');
        setTimeout(function() {          
            var elements = document.querySelectorAll('.pr-sub-change[data-attribute-id="' + id + '"]');
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(':button').prop('disabled', true);
                    var faq = this.getAttribute("data-attribute-faq");
                    $scope.onClickPriceChangeRequest(JSON.parse(faq));
                }, false);
            }
        }, 1000);
    };

    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', openPriceChangeModalFifth, false);
    }

    var elementsFirst = document.getElementsByClassName("element-first");
    var openPriceChangeModalFirstElem = function(event) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = this.getAttribute("data-attribute-id");
        angular.element(angular.element('.modal-first[data-attribute-id="' + id + '"]')[0]).modal('show');
        setTimeout(function() {  
            var elements = document.querySelectorAll('.pr-sub-change-first[data-attribute-id="' + id + '"]');
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(':button').prop('disabled', true);
                    var faq = this.getAttribute("data-attribute-faq");
                    $scope.onClickPriceChangeRequest(JSON.parse(faq));
                }, false);
            }
        }, 1000);
    };

    for (var i = 0; i < elementsFirst.length; i++) {
        elementsFirst[i].addEventListener('click', openPriceChangeModalFirstElem, false);
    }

    var elementsSecond = document.getElementsByClassName("element-second");
    var openPriceChangeModalSecondElem = function(event) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = this.getAttribute("data-attribute-id");
        angular.element(angular.element('.modal-second[data-attribute-id="' + id + '"]')[0]).modal('show');
        setTimeout(function() {  
            var elements = document.querySelectorAll('.pr-sub-change-second[data-attribute-id="' + id + '"]');
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(':button').prop('disabled', true);
                    var faq = this.getAttribute("data-attribute-faq");
                    $scope.onClickPriceChangeRequest(JSON.parse(faq));
                }, false);
            }
        }, 1000);
    };

    for (var i = 0; i < elementsSecond.length; i++) {
        elementsSecond[i].addEventListener('click', openPriceChangeModalSecondElem, false);
    }

    var elementsThird = document.getElementsByClassName("element-third");
    var openPriceChangeModalThirdElem = function(event) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = this.getAttribute("data-attribute-id");
        angular.element(angular.element('.modal-third[data-attribute-id="' + id + '"]')[0]).modal('show');
        setTimeout(function() {  
            var elements = document.querySelectorAll('.pr-sub-change-third[data-attribute-id="' + id + '"]');
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(':button').prop('disabled', true);
                    var faq = this.getAttribute("data-attribute-faq");
                    $scope.onClickPriceChangeRequest(JSON.parse(faq));
                }, false);
            }
        }, 1000);
    };

    for (var i = 0; i < elementsThird.length; i++) {
        elementsThird[i].addEventListener('click', openPriceChangeModalThirdElem, false);
    }

    var elementsFourth = document.getElementsByClassName("element-fourth");
    var openPriceChangeModalFourthElem = function(event) {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = this.getAttribute("data-attribute-id");
        angular.element(angular.element('.modal-fourth[data-attribute-id="' + id + '"]')[0]).modal('show');
        setTimeout(function() {  
            var elements = document.querySelectorAll('.pr-sub-change-fourth[data-attribute-id="' + id + '"]');
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(':button').prop('disabled', true);
                    var faq = this.getAttribute("data-attribute-faq");
                    $scope.onClickPriceChangeRequest(JSON.parse(faq));
                }, false);
            }
        }, 1000);
    };

    for (var i = 0; i < elementsFourth.length; i++) {
        elementsFourth[i].addEventListener('click', openPriceChangeModalFourthElem, false);
    }
}, 1000);

$scope.onClickPriceChangeRequest = function(faq) {
    var apiData = {
        "vendor_filter_id": faq.id,
        "vendor_id": $scope.vendorId,
        "answer_type": faq.answer_type_id
    }
    var elem;

    if(faq.answer_type_id == "1" && faq.id !== '192' && faq.id !== '193') {
        elem = angular.element('.modal-first[data-attribute-id="' + faq.id + '"]')[0];
        apiData.new_answer_value = (angular.element('.modal-first[data-attribute-id="' + faq.id + '"] .faq-answer.faq-number')[0]).value;
        if(!apiData.new_answer_value) return
        for (var i = 0; i < $('[data-idVal]').length; i++) {

            // code to get all the divs which have question_ids corresponding to the faq array
            var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      
            if ($faqDiv.hasClass('faq-number-div')) { // code to get all answers of number inputs and input them in the array
              for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                    apiData.old_answer_value = $faqDiv.find('input[type="number"]').val();
                }
              }
            }
          }
    }   
     else if(faq.answer_type_id == "1" && (faq.id === '192' || faq.id === '193')) {
         elem = angular.element('.modal-second[data-attribute-id="' + faq.id + '"]')[0]
        apiData.new_answer_value = (angular.element('.modal-second[data-attribute-id="' + faq.id + '"] .faq-answer.faq-text')[0]).value;
        if(!apiData.new_answer_value) return

        for (var i = 0; i < $('[data-idVal]').length; i++) {

            // code to get all the divs which have question_ids corresponding to the faq array
            var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      
            if ($faqDiv.hasClass('faq-text-div')) { // code to get all answers of text inputs and input them in the array
              for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                    apiData.old_answer_value = $faqDiv.find('input[type="text"]').val();
                }
              }
            }
          }
    }
    else if(faq.answer_type_id == "2") {
        elem = angular.element('.modal-third[data-attribute-id="' + faq.id + '"]')[0];
        apiData.new_answer_value = (angular.element('.modal-third[data-attribute-id="' + faq.id + '"] .faq-answer')[0]).value;
        if(!apiData.new_answer_value) return 
        apiData.new_answer_value = (apiData.new_answer_value).trim();
        for (var i = 0; i < $('[data-idVal]').length; i++) {

            // code to get all the divs which have question_ids corresponding to the faq array
            var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      
            if ($faqDiv.hasClass('faq-textarea-div')) {
              for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                    apiData.old_answer_value = ($faqDiv.find('textarea').val()).trim();
                }
              }
            }
          }
    }
    else if(faq.answer_type_id == "3") {
        elem = angular.element('.modal-fourth[data-attribute-id="' + faq.id + '"]')[0]
        if(faq.allow_multiselect == '1') {
            apiData.new_filter_option_ids = [];
            for (var z = 0; z < angular.element('.modal-fourth[data-attribute-id="' + faq.id + '"] .faq-answer:checked').length; z++) {
                apiData.new_filter_option_ids.push(angular.element('.modal-fourth[data-attribute-id="' + faq.id + '"] .faq-answer:checked')[z].getAttribute('data-optionId')) 
            }
            for (var i = 0; i < $('[data-idVal]').length; i++) {
                // code to get all the divs which have question_ids corresponding to the faq array
                var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
                // code to get all the answer ids of checkboxes and push them in the answers array
                if ($faqDiv.hasClass('faq-checkbox-div')) {
                for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                    if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                    apiData.old_filter_option_ids = [];
                    for (var z = 0; z < $faqDiv.find('input[name="checkbox-faq"]:checked').length; z++) {
                        apiData.old_filter_option_ids.push($($faqDiv.find('input[name="checkbox-faq"]:checked')[z]).attr('value'))
                        }
                    }
                }
                }
            }
        } else if(faq.allow_multiselect == '0') {
            apiData.new_filter_option_ids = [];
            apiData.new_filter_option_ids.push(angular.element('.modal-fourth[data-attribute-id="' + faq.id + '"] .faq-answer:checked')[0].getAttribute('data-optionId'));
            for (var i = 0; i < $('[data-idVal]').length; i++) {

                // code to get all the divs which have question_ids corresponding to the faq array
                var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
                if ($faqDiv.hasClass('faq-radio-div')) {
                  for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                    if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                      var id = $faqDiv.find('input[type="hidden"]').attr('data-idVal');
                      if ($faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value') != undefined && $faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value') != '') {
                          apiData.old_filter_option_ids = [];
                        apiData.old_filter_option_ids.push($faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value'));
                      }
                    }
                  }
                }
              }
        }
    }

    else if(faq.answer_type_id == "4") {
        elem = angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"]')[0];
        apiData.new_min_value = ((angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .min_value')[0]).value);
        apiData.new_max_value = ((angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .max_value')[0]).value);
        if(!apiData.new_min_value && !apiData.new_max_value) return 

        if((parseInt(apiData.new_min_value) < parseInt(faq.range.floor)) || (parseInt(apiData.new_min_value) > parseInt(faq.range.ceil)) || (parseInt(apiData.new_max_value) > parseInt(faq.range.ceil)) || (parseInt(apiData.new_max_value) < parseInt(faq.range.floor)) ) {
            return (angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .infoForm-errorText')[0]).classList.remove("minGmax");

        } else {
            (angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .infoForm-errorText')[0]).classList.add("minGmax");
        }

        if(parseInt(apiData.new_max_value) < parseInt(apiData.new_min_value)) {
            return (angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .errorPrice')[0]).classList.remove("minGmax");

        } else {
            (angular.element('.modal-fifth[data-attribute-id="' + faq.id + '"] .errorPrice')[0]).classList.add("minGmax");

        }

        for (var i = 0; i < $('[data-idVal]').length; i++) {

            // code to get all the divs which have question_ids corresponding to the faq array
            var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
            if ($faqDiv.hasClass('faq-range-div')) {
              for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
                if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == faq.id) {
                  var id = $faqDiv.find('input[type="hidden"]').attr('data-idVal');
                  $faqDiv.find('.minGmax').css('display', 'none');
                  if (Number($faqDiv.find('.min_value').val()) > Number($faqDiv.find('.max_value').val())) {
                    vendorInfoScroll('rzslider[id="' + id + '"]');
                    $faqDiv.find('.minGmax').css('display', 'block');
                    return;
                  }
                  apiData.old_min_value = $faqDiv.find('.min_value').val();
                  apiData.old_max_value = $faqDiv.find('.max_value').val();
                }
              }
            }
          }
    }

    priceLockAddRequest(config.vtoken, apiData).success(function (data) {
        angular.element(elem).modal('hide');
        $(document).find('.request-price-change').attr('disabled', true);
        alert("Success");
        setTimeout(function(){ window.location.reload(); }, 1000);
    }) 

}

  var recursionFaq = function (faqArray) {
    if (faqArray) {
      for (var i = 0; i < faqArray.length; i++) {
        if (faqArray[i].range && !$.isEmptyObject(faqArray[i].range)) {
          if (!beforeSubmitFlag) {
            faqArray[i].range.floor = Number(faqArray[i].range.min_value);
            faqArray[i].range.ceil = Number(faqArray[i].range.max_value);
          }
          if (faqArray[i].answers && faqArray[i].answers.max_value && faqArray[i].answers.min_value) {
            var minValueChange = Number(angular.copy(faqArray[i].answers.min_value));
            var maxValueChange = Number(angular.copy(faqArray[i].answers.max_value));
            faqArray[i].answers = {};
            faqArray[i].answers.min_value = minValueChange;
            faqArray[i].answers.max_value = maxValueChange;
          } else if (!faqArray[i].answers.length) {
            faqArray[i].answers.min_value = faqArray[i].range.min_value * 1;
            faqArray[i].answers.max_value = faqArray[i].range.max_value * 1;
          }
          $scope.vendorData.infoForm.faq[$scope.count.val] = {
            question_id: faqArray[i].id,
            answers: [faqArray[i].answers.min_value, faqArray[i].answers.max_value],
          }
        
        } else {

          $scope.vendorData.infoForm.faq[$scope.count.val] = {
            question_id: faqArray[i].id,
            answers: faqArray[i].answers,
          }
        
        }
        $scope.count.val++;
        if (faqArray[i].options && faqArray[i].options.length) {
          for (var j = 0; j < faqArray[i].options.length; j++) {
            if (faqArray[i].options[j].child != '0' || faqArray[i].options[j].child) {
              recursionFaq(faqArray[i].options[j].children);
            }
          }
        }
      }
    }
  }

  $timeout(function () {
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      if ($faqDiv.hasClass('faq-radio-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            var id = $faqDiv.find('input[type="hidden"]').attr('data-idVal');
            for (var j = 0; j < $faqDiv.find('input[name="radio-faq-' + id + '"]').length; j++) {
              if ($scope.vendorData.infoForm.faq[k].answers[0] == $($faqDiv.find('input[name="radio-faq-' + id + '"]')[j]).attr('value')) {
                $($faqDiv.find('input[name="radio-faq-' + id + '"]')[j]).prop("checked", true);
                $($faqDiv.find('input[name="radio-faq-' + id + '"]')[j]).closest('.checkbox-options').find('.child-multi-select').removeClass('d-n')
              }
            }
          }
        }
      }
    }
    // code for checkboxes
    for (var i = 0; i < $('[data-idVal]').length; i++) {
      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      // code to get all the answer ids of checkboxes and push them in the answers array
      if ($faqDiv.hasClass('faq-checkbox-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            if ($scope.vendorData.infoForm.faq[k].answers.length) {
              for (var j = 0; j < $scope.vendorData.infoForm.faq[k].answers.length; j++)
                for (var z = 0; z < $faqDiv.find('input[name="checkbox-faq"]').length; z++) {
                  if ($($faqDiv.find('input[name="checkbox-faq"]')[z]).attr('value') == $scope.vendorData.infoForm.faq[k].answers[j]) {
                    $($faqDiv.find('input[name="checkbox-faq"]')[z]).prop("checked", true);
                    $($faqDiv.find('input[name="checkbox-faq"]')[z]).closest('.checkbox-options').find('.child-multi-select').removeClass('d-n')
                  }
                }
            }
          }
        }
      }
    }
    // for rendering slider view according to value
    $scope.$broadcast('reCalcViewDimensions');
  }, 1000);
  $scope.addContact = function () {
    $scope.vendorData.infoForm.contactNumber.push({
      phone: '',
      is_landline: '0',
      country_code: "+91",
    });
  }

  $scope.emailOtp = {
      value: null,
    errorShow: false,
    errorText: null,
    }

    var showTimerInterval;
    var timeLeft = 30;
    var showTimer = function() {
        angular.element(document.querySelector('#email-timer-value')).css('display','block');
        if(timeLeft <= 0) {
            clearInterval(showTimerInterval);
            timeLeft = 30;
            angular.element(document.querySelector('#email-resend')).html("Resend");
            angular.element(document.querySelector('#email-timer-value')).css('display','none');
            angular.element(document.querySelector('#email-resend')).css('display','block');
        } else {
            angular.element(document.querySelector('#email-timer-value')).html("00:" + (timeLeft < 10 ? '0' + timeLeft.toString() : timeLeft.toString()));
        }
        timeLeft -= 1;
    };

    $scope.onClickAddPrimaryEmail = function () {
        angular.element(document.querySelector('#primary-email-error')).css('display','none');
        $scope.addPrimaryEmailButtonDisabled = true;
        addPrimaryEmail($scope.vendorData.infoForm.loginID, $scope.emailOtp.value).success(function(data){
            angular.element(document.querySelector('#email-timer-value')).css('display','block');
            $('#submitOtpPopup').modal('hide');
            $scope.vendorData.infoForm.isEmailDisabled = true;
              $scope.addPrimaryEmailButtonDisabled = false;
        }).catch(function(err) {
            angular.element(document.querySelector('#primary-email-error')).css('display','block');
            $scope.makePrimaryBtnDisabled = false;
        })
    }

  $scope.verifyEmail = function () {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!re.test(String($scope.vendorData.infoForm.loginID).toLowerCase())) {
        angular.element(document.querySelector('#email-err')).css('display','block');
        return
      }
      $scope.makePrimaryBtnDisabled = true;
      angular.element(document.querySelector('#email-err')).css('display','none');
      addSecondaryEmail($scope.vendorData.infoForm.loginID).then(function(data){
        sendOtpEmail($scope.vendorData.infoForm.loginID).then(function(data){
            $('#submitOtpPopup').modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#submitOtpPopup').modal('show');
            angular.element(document.querySelector('#email-resend')).css('display','none');
            showTimerInterval = setInterval(showTimer, 1000);
            $scope.makePrimaryBtnDisabled = false;
            })
    }).catch(function(err) {
        $scope.makePrimaryBtnDisabled = false;
    })
  }

  $scope.onCloseVerifyEmailPopup = function() {
        clearInterval(showTimerInterval);
        timeLeft = 30;
        angular.element(document.querySelector('#email-resend')).css('display','none');
        angular.element(document.querySelector('#email-timer-value')).css('display','none');
  }

  $scope.resendOtp = function() {
    sendOtpEmail($scope.vendorData.infoForm.loginID).then(function(data){
        angular.element(document.querySelector('#email-resend')).css('display','none');
        showTimerInterval = setInterval(showTimer, 1000);
        $scope.makePrimaryBtnDisabled = false;
        })
  }

  var vendorInfoScroll = function (id) {
    jQuery('html, body').animate({
      scrollTop: jQuery(id).offset().top - 100
    }, 500);
    return;
  }
  $scope.removePhone = function (index) {
    if ($scope.vendorData.infoForm.contactNumber && $scope.vendorData.infoForm.contactNumber.length) {
      $scope.vendorData.infoForm.contactNumber.splice(index, 1);
    }
  }
  $scope.submitInfo = function (infoData) {
    var type = [];
    $scope.errorObject = {};
    // removing min > max error in case of range sliders if in display
    $scope.vendorData.infoForm.contactNumber.forEach(function (v) {
      delete v.id
    });
    if ($scope.vendorData.infoForm.contactNumber.length > 1) {
      $scope.vendorData.infoForm.contactNumber = $scope.vendorData.infoForm.contactNumber.filter(function (v) {
        return v.phone != '';
      });
    }
    $scope.count.val = 0;
    if ($('form[name="personalInfoForm"]').hasClass('ng-invalid')) {
      if ($('form[name="personalInfoForm"]').hasClass('ng-invalid-required')) {
        $scope.errorObject.required = true;
      }
      vendorInfoScroll('form[name="personalInfoForm"]')
      // jQuery('html, body').animate({
      //     scrollTop: jQuery('form[name="personalInfoForm"]').offset().top - 100
      // }, 500);
      return;
    }
    if ($scope.vendorInfo.faq.length) {
      recursionFaq($scope.vendorInfo.faq);
    }
    // code for checkboxes
    for (var i = 0; i < $('[data-idVal]').length; i++) {
      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      // code to get all the answer ids of checkboxes and push them in the answers array
      if ($faqDiv.hasClass('faq-checkbox-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            if(!$scope.vendorData.infoForm.faq[k].first) {
                $scope.vendorData.infoForm.faq[k].answers = [];

                for (var z = 0; z < $faqDiv.find('input[name="checkbox-faq"]:checked').length; z++) {
                    $scope.vendorData.infoForm.faq[k].answers.push($($faqDiv.find('input[name="checkbox-faq"]:checked')[z]).attr('value'))
                }
                $scope.vendorData.infoForm.faq[k].first = true
            }
          }
        }
      }
    }

    // code for number inputs
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');

      if ($faqDiv.hasClass('faq-number-div')) { // code to get all answers of number inputs and input them in the array
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
           
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
              if(!$scope.vendorData.infoForm.faq[k].first) {
                $scope.vendorData.infoForm.faq[k].answers = $faqDiv.find('input[type="number"]').val();
                $scope.vendorData.infoForm.faq[k].is_default = $faqDiv.find('input[name="set-default"]').attr("ng-checked");
                $scope.vendorData.infoForm.faq[k].first = true;
              }
          }
        }
      }
    }

    // code for text inputs
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');

      if ($faqDiv.hasClass('faq-text-div')) { // code to get all answers of text inputs and input them in the array
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            if(!$scope.vendorData.infoForm.faq[k].first) {
                $scope.vendorData.infoForm.faq[k].answers = $faqDiv.find('input[type="text"]').val();
                $scope.vendorData.infoForm.faq[k].is_default = $faqDiv.find('input[name="set-default"]').attr("ng-checked");
                $scope.vendorData.infoForm.faq[k].first = true;
            }
          }
        }
      }
    }

    // code for textarea fields
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');

      if ($faqDiv.hasClass('faq-textarea-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            if(!$scope.vendorData.infoForm.faq[k].first) {

                $scope.vendorData.infoForm.faq[k].answers = $faqDiv.find('textarea').val();
                $scope.vendorData.infoForm.faq[k].first = true;

            }
          }
        }
      }
    }
    // code for radio buttons
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      if ($faqDiv.hasClass('faq-radio-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            var id = $faqDiv.find('input[type="hidden"]').attr('data-idVal');
            

            if ($faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value') != undefined && $faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value') != '') {
                if(!$scope.vendorData.infoForm.faq[k].first) {
                    $scope.vendorData.infoForm.faq[k].answers = [];
                    $scope.vendorData.infoForm.faq[k].answers.push($faqDiv.find('input[name="radio-faq-' + id + '"]:checked').attr('value'));
                    $scope.vendorData.infoForm.faq[k].first = true;

                }
            }
        
          }
        }
      }
    }
    //code for range sliders
    for (var i = 0; i < $('[data-idVal]').length; i++) {

      // code to get all the divs which have question_ids corresponding to the faq array
      var $faqDiv = $($('[data-idVal]')[i]).closest('.faq-answer-div');
      if ($faqDiv.hasClass('faq-range-div')) {
        for (var k = 0; k < $scope.vendorData.infoForm.faq.length; k++) {
          if ($faqDiv.find('input[type="hidden"]').attr('data-idVal') == $scope.vendorData.infoForm.faq[k].question_id) {
            var id = $faqDiv.find('input[type="hidden"]').attr('data-idVal');
            $faqDiv.find('.minGmax').css('display', 'none');
            if (Number($faqDiv.find('.min_value').val()) > Number($faqDiv.find('.max_value').val())) {
              vendorInfoScroll('rzslider[id="' + id + '"]');
              $faqDiv.find('.minGmax').css('display', 'block');
              return;
            }
         
            if(!$scope.vendorData.infoForm.faq[k].first) {
                $scope.vendorData.infoForm.faq[k].answers = [];

            $scope.vendorData.infoForm.faq[k].answers.push($faqDiv.find('.min_value').val(), $faqDiv.find('.max_value').val());
            $scope.vendorData.infoForm.faq[k].first = true;

            }
          }
        }
      }
    }
    // if ( $('.infoForm-errorText').length) {
    //   return;
    // }
    $('#vendor-info-save').html('');
    $('.save-info-loader').css('display', 'block');

    updateVendorInfo(config.vtoken, $scope.vendorId, $scope.vendorData.infoForm.bName, $scope.vendorData.infoForm.pName, $scope.vendorData.infoForm.addID, $scope.vendorData.infoForm.facebookLink, $scope.vendorData.infoForm.web_link, $scope.vendorData.infoForm.instaLink, $scope.vendorData.infoForm.vimeoLink, $scope.vendorData.infoForm.baseCity, $scope.vendorData.infoForm.category_id, $scope.vendorData.infoForm.contactNumber, $scope.vendorData.infoForm.faq,$scope.vendorData.infoForm.vendor_bio,).success(function (data) {
      $scope.vendorData.hasBaseCity = true;
      $('.save-info-loader').css('display', 'none');
      $('#vendor-info-save').html('SAVE');
      if ($scope.vendorData.status == 'N') {
        $("#new-vendor-popup").modal('show');
        setTimeout(function(){ window.location.reload(); }, 5000);
        // $state.go('main.albums',{'id':$scope.vendorId,'r':'true'},{reload: false});
      } else {
        window.location.reload();
      }
    })
  }
  $scope.storeInformation = {};
  $scope.storeInformation.value = 0;
  var getStoreInfoFunction = function () {

    getStoreInfo(config.vtoken, $scope.vendorId).success(function (data) {
      if (data.length) {
        $scope.storeInformation = data;
        $scope.storeInformation.value = 1;
      }
    });
  }
  getStoreInfoFunction();
  $scope.resetField = function () {
    //$scope.storeName = "";
    $scope.address = "";
    $scope.phone = "";
    $scope.email = "";
    $scope.landmark = "";
    $scope.pincode = "";
    $('#pincode').val('');
    $('#pincodeLandmark').val('');
    $('#city').val('');
    $('#cityLandmark').val('');
    $('#locality').val('')
    $('#localityLandmark').val('');
    $('#state').val('');
    $('#stateLandmark').val('');
    $('#country').val('');
    $('#countryLandmark').val('');
    $('#sublocality').val('');
    $('#sublocalityLandmark').val('');
    $('#latbox').val('');
    $('#latboxLandmark').val('');
    $('#lngbox').val('');
    $('#lngboxLandmark').val('');
    $scope.storeForm.$setPristine();
  }
  $scope.addStore = function () {
    if ($("#latboxLandmark").val() == 0) {
      $('.invalid-landmark').css('display', 'block');
      return;
    }
    var data = {
      vendorId: $scope.vendorId,
      //isPrimary: "false",
      //storeTitle: $scope.storeName,
      landmark: $('#storeAddress').val(),
      type: 'store',
      isVerified: "",
      //status: 1,
      completeAddress: $('#pac-input').val(),
      latitude: $('#latbox').val(),
      longitude: $('#lngbox').val()
    }


    data.city = $('#city').val() ? $('#city').val() : $('#cityLandmark').val();
    data.state = $('#state').val() ? $('#state').val() : $('#stateLandmark').val();
    data.country = $('#country').val() ? $('#country').val() : $('#countryLandmark').val();
    data.locality = $('#locality').val() ? $('#locality').val() : $('#localityLandmark').val();
    data.sublocality = $('#sublocality').val() ? $('#sublocality').val() : $('#sublocalityLandmark').val();
    data.latitude = $('#latbox').val() ? $('#latbox').val() : $('#latboxLandmark').val();
    data.longitude = $('#lngbox').val() ? $('#lngbox').val() : $('#lngboxLandmark').val();
    data.pincode = $('#pincode').val() ? $('#pincode').val() : ($('#pincodeLandmark').val() ? $('#pincodeLandmark').val() : $scope.pincode);

    addStoreInfo(config.vtoken, data).success(function (data) {
      //$window.location.reload();
      $scope.resetField();
      $('#MapPopup').modal('hide');
      getStoreInfoFunction();

    });
    //$('#MapPopup').modal('hide');
  }
  $scope.editAddStore = function (storeId, addressId, contactId) {
    var editData = {
      storeId: storeId,
      //storeTitle: $scope.storeTitle,
      addressId: addressId,
      landmark: $('#editstoreAddress' + storeId).val(),
      pincode: $scope.storePincode,
      completeAddress: $('#store_desc' + storeId).val(),
      vendorId: $scope.vendorId,
      type: "store",
    }


    editData.city = $('#city' + storeId).val() ? $('#city' + storeId).val() : $('#cityLandmark' + storeId).val();
    editData.state = $('#state' + storeId).val() ? $('#state' + storeId).val() : $('#stateLandmark' + storeId).val();
    editData.country = $('#country' + storeId).val() ? $('#country' + storeId).val() : $('#countryLandmark' + storeId).val();
    editData.locality = $('#locality' + storeId).val() ? $('#locality' + storeId).val() : $('#localityLandmark' + storeId).val();
    editData.sublocality = $('#sublocality' + storeId).val() ? $('#sublocality' + storeId).val() : $('#sublocalityLandmark' + storeId).val();
    editData.latitude = $('#latbox' + storeId).val() ? $('#latbox' + storeId).val() : $('#latboxLandmark' + storeId).val();
    editData.longitude = $('#lngbox' + storeId).val() ? $('#lngbox' + storeId).val() : $('#lngboxLandmark' + storeId).val();
    editData.pincode = $('#pincode' + storeId).val() ? $('#pincode' + storeId).val() : ($('#pincodeLandmark' + storeId).val() ? $('#pincodeLandmark' + storeId).val() : $scope.storePincode);

    editStoreInfo(config.vtoken, editData).success(function (data) {
      getStoreInfoFunction();
      $('#editMapPopup').modal('hide');
      $scope.resetField();
      //$window.location.reload();
    });
  }
  $scope.editModal = function (store) {
    $scope.storeId = store.addressId;
    //$scope.storeTitle = store.storeTitle;
    $scope.storePincode = store.pincode;
    $scope.storeCompleteAddress = store.landmark;
    $scope.storeLandmark = store.completeAddress;
    $scope.addressId = store.addressId;
    $('#editMapPopup').modal('show');
    editMap(store.addressId, store.longitude, store.latitude);
  }
}]);

vendorApp.controller('albumImageController', ['$scope', '$stateParams', '$state', '$q', 'getAllImages', 'config', 'Upload', '$timeout', 'makeCoverPhoto', 'deletePhotoGet', 'ngDialog', 'imageOrder', 'vendorData', 'ngToast', function ($scope, $stateParams, $state, $q, getAllImages, config, Upload, $timeout, makeCoverPhoto, deletePhotoGet, ngDialog, imageOrder, vendorData, ngToast) {

  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  $scope.section = $stateParams.section;
  $scope.addNewImage;
  $scope.id = $stateParams.Pid;
  $scope.files = "";
  $scope.checkboxModel = {};
  $scope.showLoader = false;
  //console.log("console.log(localStorage.getItem('image_terms'));",localStorage.getItem('image_terms'));
  //$scope.checkboxModel.imageTerms = localStorage.getItem('image_terms') ? true : false;
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  var getAllImagesFunction = function () {

    getAllImages(config.vtoken, $scope.section, $scope.id).success(function (data) {
      // code commented out as the order from the API is correct, no need of frontend reordering whatsoever - DA
      // data.data.images.sort(function(x, y){
      // 	return Number(y.image_order) - Number(x.image_order);
      // });

      if (data.data.images.filter(function (x) { return !x.image_order }).length) {
        var newOrder = data.data.images.map(function (x, i) {
          return Object.assign({}, x, { image_order: i + 1 }); // order was asked to be reversed. last_change - DA
        });
        imageOrder(config.vtoken, newOrder).then(function (x) {
          console.log('order updated');
        });
      }

      data.data.images.forEach(function (obj) {
        if (obj.thumb_status == 0) {
          var imageUrl = obj.original_image_url;
          obj.actualImageUrl = imageUrl;
        } else {
          var imageUrl = obj.image_url.replace('%%', '270');
          obj.actualImageUrl = imageUrl;
        }
        obj.hover = false;
      });
      $scope.imageData.imageInfo = data.data;
      $scope.imageData.imageInfo.details = data.data.details;
      $scope.remainingImage = $scope.imageData.imageInfo.details.max_image - $scope.imageData.imageInfo.details.image_count;
      $scope.pemProfilePicDisable = $scope.imageData.imageInfo.details.pem_profile_pic_disable;
      $scope.imageData.imageInfo.images = data.data.images;
      if ($scope.imageData.imageInfo.images.length >= 30 && $stateParams.section === 'member') {
        $scope.addNewImage = 0;
      } else {
        $scope.addNewImage = 1;
      }
      //$('.albumInfo').css('display','none');
      //$('.image-info').css('display','block');
    });
  }
  getAllImagesFunction();

  $scope.makeAlbumCover = function (image, event) {
    $scope.showLoader = true;
    var makeCoverData = {
      "image_id": image.image_id,
      "project_id": image.resource_id
    }
    var url = '/api/v1/vendor/album/cover?version=1.1&token=' + config.vtoken;
    makeCoverPhoto(makeCoverData, url).success(function (data) {
      $scope.showLoader = false;
      ngToast.create({
        content: 'album cover pic set successfully',
        timeout: 4000,
        dismissOnTimeout: true,
        dismissButton: true,
        className: 'success'
      });
    });
  }

  $scope.makeCoverPic = function (image, event) {
    var vendorId = JSON.parse(localStorage.redux).profile.profile.vendor_id;
    window.open('/crop-image?image=' + image.image_url.replace('%%', 800) + '&vendorid=' + vendorId + '&imageid=' + image.image_id, 'Crop Image', 'width=1242, height=775, innerHeight=825, location=no, menubar=no, status=no, titlebar=no, scrollbars=no');
    return;
    // if(parseInt(image.image_width) < 500) {
    //   ngDialog.open({
    //     template: 'coverPicLimit'
    //   });
    //   return;
    // }
    // $scope.showLoader = true;
    // var makeCoverData = {
    //   "image_id": image.image_id,
    //   "project_id": image.resource_id
    // }
    // var url = '/api/v1/vendor/photo/cover?version=1.1&token=' + config.vtoken;
    // makeCoverPhoto(makeCoverData, url).success(function(data) {
    // 	$scope.showLoader = false;
    // 	console.log('profile pic set');
    // 	ngToast.create({
    // 		content: 'profile pic set successfully',
    // 		timeout: 4000,
    // 		dismissOnTimeout: true,
    // 		dismissButton:true,
    // 		className: 'success'
    // 	});
    // });
  }

  $scope.hoverIn = function () {
    this.hoverText = true;
  };

  $scope.hoverOut = function () {
    this.hoverText = false;
  };

  $(window).scroll(function () {
    if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      if ($('.r-save-inside').length && !$('.r-save-inside').isOnScreenVertical()) {
        $('.r-save-outside').removeClass('hide').addClass('w-100');
        if ($('.left-fb').length && !$('.left-fb').isOnScreenVertical()) {
          $('.save-changes-div').addClass('fixedSaveChanges');
        } else {
          $('.save-changes-div').removeClass('fixedSaveChanges');
        }
      } else {
        $('.r-save-outside').addClass('hide').removeClass('w-100');
      }
    }
  });

  $scope.delImage = function (image, event) {
    $scope.selectedId = [image.image_id, event];
    //  alert(image.is_profile_pic);

    if (image.is_profile_pic == "1") {
      ngDialog.open({
        template: 'warningTemplateId',
      })
    } else {
      ngDialog.open({
        template: 'selectTemplateId',
        scope: $scope,
        data: $scope.selectedId,
      })
    }
  }
  $scope.sendRequest = function (imageId, event) {
    var a = $(event.target).html();
    $(event.target).next().css('display', 'block');
    $(event.target).html('');
    //console.log("delete", image)
    deletePhotoGet(config.vtoken, imageId).success(function (data) {
      //console.log("deleteResponse", data);
      $(event.target).next().css('display', 'none');
      $(event.target).html(a);
      getAllImagesFunction();
    });
  }

  $scope.uploadFiles = function (files, errFiles, id, name) {
    console.log(files, errFiles);
    $('.add-new-image-block').css('display', 'none');
    $scope.files = files;
    $scope.errFiles = errFiles;
    var remainingFiles = $scope.remainingImage;
    var extraFiles = $scope.files.length - remainingFiles;
    var flag = 1;
    var imageCount = 0;
    var imageSuccess = 0;
    var errFlag = 0;
    if ((files.length + errFiles.length) > 20) {
      ngDialog.open({
        template: 'maxFilesMessage'
      });
      // return;
    }
    else {
      errFiles.forEach(function (errFile) {
        $scope.selectedId = [errFile.name];
        ngDialog.open({
          template: 'selectErrorMessage',
          scope: $scope,
          data: $scope.selectedId,
        })
      });
    }
    var sequence = $q.defer();
    var imagesArray = $scope.imageData.imageInfo.images || [];
    var lastKey = Math.max(Math.max.apply(Math, imagesArray.map(function (o) { return o.image_order; })), imagesArray.length);
    console.log(lastKey, imagesArray, imagesArray.length);
    sequence.resolve();
    sequence = sequence.promise;
    angular.forEach(files, function (file, key) {
      sequence = sequence.then(function () {
        // return {
        imageCount++;
        if (imageCount > remainingFiles && flag) {
          file.loader = 0;
          flag = 0;
          $scope.selectedId = [extraFiles];
          console.log($scope.selectedId);
          ngDialog.open({
            template: 'selectMaxMessage'
          })
          return;
        }
        else if (imageCount <= remainingFiles) {
          file.loader = 1;
          file.upload = Upload.upload({
            url: config.domain + '/api/v1/vendor/upload/image?version=1.1&token=' + config.vtoken,
            data: {
              order: Number(lastKey) + key + 1,
              image: file,
              resource_id: $scope.id,
              resource_name: $scope.section,
            }
          }).then(function (response) {
            file.loader = 0;
            $timeout(function () {
              if (errFlag != 1 && (response.data.response.status == false || response.status != 200)) {
                errFlag = 1;
                ngDialog.open({
                  template: 'uploadErrorMessage'
                });
              }
              file.result = response.data;
              getAllImagesFunction();
              imageSuccess++;
              if (imageCount == imageSuccess) {
                $('.add-new-image-block').css('display', 'block');
              }
              return file;
            }, 0);
          }, function (err) {
            file.loader = 0;
            $('.add-new-image-block').css('display', 'block');
            $scope.displayError = "One or more images could not be uploaded, Please try again.";
            $timeout(function () {
              $scope.displayError = undefined;
            }, 7000);
            if (err.status > 0) $scope.errorMsg = err.status + ': ' + err.data;
          }, function (evt) {
            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
        }
        // }
        $scope.errorFileshow = true;
      });
    })
  }

  $timeout(function () {
    //console.log("localStorage.getItem",localStorage.getItem('image_terms'));
    if (localStorage.getItem('image_terms') == 'true') {
      //console.log("if");
      $scope.checkboxModel.imageTerms = true;
      $('.caption-terms').css('color', 'green');
      $('.grey-text-terms').css('color', 'white');
    } else {
      //console.log("else");
      $('.caption-terms').css('color', 'red');
      $('.grey-text-terms').css('color', 'grey');
      $scope.checkboxModel.imageTerms = false;
    }
  }, 1000)
  $scope.termChange = function () {
    //console.log("checkTerm", $scope.checkboxModel.imageTerms, $('.caption-terms'), $('.grey-text'));
    if ($scope.checkboxModel.imageTerms) {
      $('.caption-terms').css('color', 'green');
      $('.grey-text-terms').css('color', 'white');
      $('.error-label').css('display', 'none');
      localStorage.setItem('image_terms', 'true');
      //console.log("console.log(localStorage.getItem('image_terms'));",localStorage.getItem('image_terms'));
    } else {
      $('.caption-terms').css('color', 'red');
      $('.grey-text-terms').css('color', 'grey');
      localStorage.setItem('image_terms', 'flase');
      //console.log("console.log(localStorage.getItem('image_terms'));",localStorage.getItem('image_terms'));
    }
  }
  $scope.checkTerms = function () {
    if ($scope.checkboxModel.imageTerms == false || $scope.checkboxModel.imageTerms == undefined) {
      $('.error-label').css('display', 'block');
    } else {
      $('.error-label').css('display', 'none');
    }
  }

}]);

vendorApp.controller('inboxMessageController', ['$scope', '$stateParams', '$state', 'config', '$timeout', 'getInboxMessage', 'postReplyMessage', 'vendorData', function ($scope, $stateParams, $state, config, $timeout, getInboxMessage, postReplyMessage, vendorData) {
  // scroll to class = inbox-title row

  jQuery('html, body').animate({
    scrollTop: jQuery('.inbox-title').offset().top - 100
  }, 500);

  $scope.imageInfo = {};
  $scope.imageInfo.replyMessage = "";
  $scope.id = $stateParams.threadId;
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  getInboxMessage(config.vtoken, $scope.id).success(function (data) {
    data.data.forEach(function (obj) {
      var senderId = obj.member_id;
      data.users.forEach(function (user) {
        var memberId = user.member_id;
        if (senderId == memberId) {
          var imageUrl = user.profile_pic_url;
          obj.userName = user.name;
          obj.actualImageUrl = imageUrl.replace('%%', '270');
        }

      })
    })
    $scope.imageInfo.data = data.data.reverse();
    $scope.imageInfo.users = data.users;
    /*console.log("users",data.users);
    $scope.imageInfo.userPic = data.users[0].role == 'user' ? (data.users[0].thumb_status ? data.users[0].original_pic_url : data.users[0].profile_pic_url) : data.users[1].profile_pic_url;
    $scope.imageInfo.vendorPic = data.users[0].role == 'vendor' ? data.users[0].profile_pic_url : data.users[1].profile_pic_url;*/
  });
  $scope.replyMessageButton = function (messageData) {
    postReplyMessage(config.vtoken, $stateParams.threadId, $scope.imageInfo.replyMessage).success(function (data) {
      $scope.imageInfo.replyMessage = "";
      getInboxMessage(config.vtoken, $scope.id).success(function (data) {
        data.data.forEach(function (obj) {
          var senderId = obj.member_id;
          data.users.forEach(function (user) {
            var memberId = user.member_id;
            if (senderId == memberId) {
              var imageUrl = user.profile_pic_url;
              obj.actualImageUrl = imageUrl.replace('%%', '270');
            }

          })
        })
        $scope.imageInfo.data = data.data.reverse();
        $scope.imageInfo.users = data.users;
        $scope.imageInfo.userPic = data.users[0].role == 'user' ? (data.users[0].thumb_status ? data.users[0].original_pic_url : data.users[0].profile_pic_url) : data.users[1].profile_pic_url;
        $scope.imageInfo.vendorPic = data.users[0].role == 'vendor' ? data.users[0].profile_pic_url : data.users[1].profile_pic_url;
      });

    })
  }
  $scope.textAreaExpand = function (event, index) {
    //console.log("keyup",event, $scope.reviewInfo[index].reviewMessage,event.target.attributes.rows.value, $scope.reviewInfo[index].reviewMessage.length);
    var tshc = event.target.scrollHeight;
    //console.log("height",tsh);
    if (tshc < 112) {
      $(event.target).css('overflow', 'hidden')
      $(event.target).css('height', 0);
      var tsh = event.target.scrollHeight + 'px';
      $(event.target).css('height', tsh);
    } else {
      $(event.target).css('overflow', 'auto')
    }
    /*this.style.overflow = 'hidden';
    this.style.height = 0;
    this.style.height = this.scrollHeight + 'px';*/
  }

}]);

vendorApp.controller('locationController', ['$scope', '$timeout', '$state', 'vendorData', 'config', 'addStoreInfo', 'getStoreInfo', 'editStoreInfo', '$window', 'delStoreInfo', 'ngDialog', function ($scope, $timeout, $state, vendorData, config, addStoreInfo, getStoreInfo, editStoreInfo, $window, delStoreInfo, ngDialog) {
  $scope.vendorData = vendorData.data.data;
  $scope.vendorId = $scope.vendorData.vendor_id;
  $scope.storeInformation = {};
  $scope.storeInformation.value = 0;
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  var getStoreInfoFunction = function () {

    getStoreInfo(config.vtoken, $scope.vendorId).success(function (data) {
      if (data.length) {
        $scope.storeInformation = data;
        $scope.storeInformation.value = 1;
      } else {
        $scope.storeInformation.value = 0;
      }
    });
  }
  getStoreInfoFunction();
  $scope.resetField = function () {
    $scope.storeName = "";
    $scope.address = "";
    $scope.phone = "";
    $scope.email = "";
    $scope.landmark = "";
    $scope.pincode = "";
    $scope.phone = undefined;
    $scope.email = undefined;
    $scope.contactName = undefined;
    $('#pincode').val('');
    $('#pincodeLandmark').val('');
    $('#city').val('');
    $('#cityLandmark').val('');
    $('#locality').val('')
    $('#localityLandmark').val('');
    $('#state').val('');
    $('#stateLandmark').val('');
    $('#country').val('');
    $('#countryLandmark').val('');
    $('#sublocality').val('');
    $('#sublocalityLandmark').val('');
    $('#latbox').val('');
    $('#latboxLandmark').val('');
    $('#lngbox').val('');
    $('#lngboxLandmark').val('');
    $scope.storeForm.$setPristine();
  }
  $scope.addStore = function () {
    if ($("#latboxLandmark").val() == 0) {
      $('.invalid-landmark').css('display', 'block');
      return;
    }
    var data = {
      vendorId: $scope.vendorId,
      isPrimary: "",
      storeTitle: $scope.storeName,
      landmark: $('#storeAddress').val(),
      type: 'store',
      isVerified: "",
      //status: 1,
      completeAddress: $('#pac-input').val(),
    }
    data.city = $('#city').val() ? $('#city').val() : $('#cityLandmark').val();
    data.state = $('#state').val() ? $('#state').val() : $('#stateLandmark').val();
    data.country = $('#country').val() ? $('#country').val() : $('#countryLandmark').val();
    data.locality = $('#locality').val() ? $('#locality').val() : $('#localityLandmark').val();
    data.sublocality = $('#sublocality').val() ? $('#sublocality').val() : $('#sublocalityLandmark').val();
    data.latitude = $('#latbox').val() ? $('#latbox').val() : $('#latboxLandmark').val();
    data.longitude = $('#lngbox').val() ? $('#lngbox').val() : $('#lngboxLandmark').val();
    data.pincode = $('#pincode').val() ? $('#pincode').val() : ($('#pincodeLandmark').val() ? $('#pincodeLandmark').val() : $scope.pincode);

    if ($scope.phone != undefined || $scope.email != undefined || $scope.contactName != undefined) {
      data["contact"] = [];
      data.contact[0] = {};
      if ($scope.phone != undefined) {
        data.contact[0].phone = $scope.phone;
      }
      if ($scope.email != undefined) {
        //console.log($scope.email, "email");
        data.contact[0].email = $scope.email;
      }
      if ($scope.contactName != undefined) {
        data.contact[0].contactName = $scope.contactName;
      }
      /*  data.contact[data.contact.length] = {
          "status": "true"
        }*/
    }
    addStoreInfo(config.vtoken, data).success(function (data) {
      //$window.location.reload();
      $scope.resetField();
      $('#MapPopup').modal('hide');
      getStoreInfoFunction();

    });

  }
  $scope.editAddStore = function (storeId, addressId, contactId) {
    var editData = {
      storeId: storeId,
      storeTitle: $scope.storeTitle,
      addressId: addressId,
      landmark: $('#editstoreAddress' + storeId).val(),
      completeAddress: $('#store_desc' + storeId).val(),
      vendorId: $scope.vendorId,
      type: "store",
    }
    if ($scope.phone != undefined || $scope.email != undefined || $scope.contactName != undefined) {
      editData["contact"] = [];
      editData.contact[0] = {};
      if ($scope.phone != undefined) {
        editData.contact[0].phone = $scope.phone;
      }
      if ($scope.email != undefined) {
        //console.log($scope.email, "email");
        editData.contact[0].email = $scope.email;
      }
      if ($scope.contactName != undefined) {
        editData.contact[0].contactName = $scope.contactName;
      }
      editData.contact[0].id = contactId;
    }
    editData.city = $('#city' + storeId).val() ? $('#city' + storeId).val() : $('#cityLandmark' + storeId).val();
    editData.state = $('#state' + storeId).val() ? $('#state' + storeId).val() : $('#stateLandmark' + storeId).val();
    editData.country = $('#country' + storeId).val() ? $('#country' + storeId).val() : $('#countryLandmark' + storeId).val();
    editData.locality = $('#locality' + storeId).val() ? $('#locality' + storeId).val() : $('#localityLandmark' + storeId).val();
    editData.sublocality = $('#sublocality' + storeId).val() ? $('#sublocality' + storeId).val() : $('#sublocalityLandmark' + storeId).val();
    editData.latitude = $('#latbox' + storeId).val() ? $('#latbox' + storeId).val() : $('#latboxLandmark' + storeId).val();
    editData.longitude = $('#lngbox' + storeId).val() ? $('#lngbox' + storeId).val() : $('#lngboxLandmark' + storeId).val();
    editData.pincode = $('#pincode' + storeId).val() ? $('#pincode' + storeId).val() : ($('#pincodeLandmark' + storeId).val() ? $('#pincodeLandmark' + storeId).val() : $scope.storePincode);
    editStoreInfo(config.vtoken, editData).success(function (data) {
      getStoreInfoFunction();
      $scope.resetField();
      $('#editMapPopup').modal('hide');
      //$window.location.reload();
    });
  }
  $scope.editModal = function (store) {
    $scope.storeId = store.storeId;
    $scope.storeTitle = store.storeTitle;
    $scope.storePincode = store.pincode;
    $scope.storeCompleteAddress = store.landmark;
    $scope.storeLandmark = store.completeAddress;
    $scope.addressId = store.addressId;

    if (store.contact) {
      $scope.contactId = store.contact[0].id;
      $scope.contactName = store.contact[0].contactName;
      $scope.email = store.contact[0].email;
      $scope.phone = store.contact[0].phone == null ? '' : Number(store.contact[0].phone);
    }
    $('#editMapPopup').modal('show');
    editMap(store.storeId, store.longitude, store.latitude);
    //initAutocompleteEdit(store.storeId, store.longitude, store.latitude)
  }
  /*$scope.delStore = function(store, event) {
    console.log(store);
    var storeContactId =  store.contact ? store.contact[0].id : 0;
    var data = {
      'storeId': store.storeId,
      "vendorId" : store.vendorId,

    }
    if(storeContactId) {
      data.contactId = storeContactId;
    }

  }*/

  $scope.delStore = function (store, event) {
    var storeContactId = store.contact ? store.contact[0].id : 0;

    $scope.selectedId = [store.storeId, store.vendorId, storeContactId];
    ngDialog.open({
      template: 'selectTemplateId',
      scope: $scope,
      data: $scope.selectedId,
    })
  }
  $scope.sendRequest = function (storeId, vendorId, contactId) {
    var data = {
      'storeId': storeId,
      "vendorId": vendorId,
    }
    if (contactId) {
      data.contactId = contactId;
    }
    delStoreInfo(config.vtoken, data).success(function (data) {
      getStoreInfoFunction();
    });
  }
}]);
vendorApp.controller('LeadsController', ['$scope', '$window', '$rootScope', '$timeout', '$state', 'leadsDashboard', 'callMaskNumber', 'leadsGraph', 'config', 'callsReceived', 'generalEnquiry', 'messageReceived', 'vcDetail', 'callHistory', 'oldQuote', 'bookingLeads', 'vendorData', 'suggestionLeads', '$location', function ($scope, $window, $rootScope, $timeout, $state, leadsDashboard, callMaskNumber, leadsGraph, config, callsReceived, generalEnquiry, messageReceived, vcDetail, callHistory, oldQuote, bookingLeads, vendorData, suggestionLeads, $location) {

  $scope.filter = 'monthly';
  $scope.filtin = {};
  var graphFetchingData = false;
  $timeout(function () {
    $('.leadsScrollSection').perfectScrollbar();
  });
  $scope.category_id = vendorData.data.data.category_id;
  // function to partition graph data and display -Aakash

  function callMaskLeads() {
    callMaskNumber('1', 'mask_number', 'desc').then(function (data) {
      $scope.allCallMasks = data.data.data
      $scope.callMasks = angular.copy($scope.allCallMasks);
    })
  }
  if ($scope.vendorData.role[0] != 'ROLE_BRAND_VENDOR') {
    callMaskLeads();
  }
  $scope.getGraphInfo = function (filter) {
    $('.graph-filter').css('background-color', 'background-color: rgba(128, 128, 128, 0.11)');
    $('.' + filter).css('background-color', 'white');
    $scope.graphData = [];
    $scope.labels = [];
    $scope.datapoints = [];
    $scope.highestLeads = [];
    $scope.averageLeads = [];
    $scope.month = false;
    graphFetchingData = true;
    $scope.myObj = '';
    leadsGraph(config.vtoken, $scope.vendorId, $scope.filter, $scope.vendorData.role[0]).success(function (data) {
      graphFetchingData = false;
      $scope.graphInfo = angular.copy(data.data);
      $scope.graphTotal = data.total;
      $scope.graphTotal.leads_difference = angular.copy(Number(data.total.leads_difference));
      $scope.graphTotal.total = angular.copy(Number(data.total.total));
      for (var key in $scope.graphInfo) {
        if (!isNaN(key)) {
          $scope.graphData.push($scope.graphInfo[key]);
        }
      }
      if ($scope.filter == 'daily') {
        $scope.graphData.sort(function (obj1, obj2) {
          // Ascending: first age less than the previous
          return obj1.day_no - obj2.day_no;
        });
      }
      for (var i = 0; i < $scope.graphData.length; i++) {
        switch ($scope.filter) {
          case 'daily':
            $scope.labels.push($scope.graphData[i].day_name)
            break;
          case 'weekly':
            var date = moment().year($scope.graphData[i].year * 1).week($scope.graphData[i].week_no);
            var presentdate = date.date()
            var presentmonth = date.format('MMM');
            var nextweek = date.add(1, 'weeks');
            var nextdate = nextweek.date();
            var nextmonth = nextweek.format('MMM')
            var finaldate = presentdate + ' ' + presentmonth + '-' + nextdate + ' ' + nextmonth;
            $scope.labels.push(finaldate);
            break;
          case 'monthly':
            $scope.month = true;
            $scope.labels.push($scope.graphData[i].month)
            break;
        }
      }
      if ($scope.filter != 'daily') {
        $scope.labels.reverse();
        $scope.graphData.reverse();
      }
      $scope.series = ["total", "highest_leads", "average_leads"];

      for (var i = 0; i < $scope.graphData.length; i++) {
        $scope.datapoints.push(Number($scope.graphData[i].total));
        if ($scope.filter == 'monthly') {
          $scope.highestLeads.push(($scope.graphData[i].highest_leads));
          $scope.averageLeads.push(($scope.graphData[i].average_leads));
        }
      }
      if ($scope.filter == 'monthly') {
        $scope.month = true;
        $scope.city = vendorData.data.data.city;
        $scope.category = vendorData.data.data.category_name;
        $scope.lastMonth = $scope.labels[$scope.graphData.length - 2];
        $scope.high = $scope.highestLeads[$scope.graphData.length - 2];
        $scope.yourLeads = $scope.datapoints[$scope.graphData.length - 2];
        $scope.average = $scope.averageLeads[$scope.graphData.length - 2];
        var highTen = ($scope.high - ($scope.high / 10));
        if ($scope.yourLeads < $scope.average) {
          $scope.obj = "low";
        } else if ($scope.yourLeads > $scope.average && $scope.yourLeads < highTen) {
          $scope.obj = "btw";
        } else {
          $scope.obj = "high";
        }
        $scope.datapointsCont = [$scope.datapoints];
      } else {
        $scope.datapointsCont = [$scope.datapoints];
      }
    })
  }
  // initially showing daily
  $rootScope.$on('brand_filter', function (event, data) {
    if (!data.checked) {
      var index = $scope.vendorArr.indexOf(data.id);
      $scope.vendorArr.splice(index, 1);
      if (!$scope.vendorArr.length) {
        $scope.vendorId = $scope.originalVendorIds;
      } else {
        $scope.vendorId = $scope.vendorArr.join();
      }
    } else {
      $scope.vendorArr.push(data.id);
      $scope.vendorId = $scope.vendorArr.join();
    }
    $scope.getGraphInfo($scope.filter);
    callsReceivedFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
    generalEnquiryFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
    messageReceivedFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
    bookingLeadsFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
    oldQuoteFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
    // suggestionLeadsFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
  });

  $scope.getGraphInfo($scope.filter);
  $scope.changeGraphFilter = function (filter) {
    if (!graphFetchingData) {
      $scope.filter = filter;
      $scope.getGraphInfo($scope.filter);
    }
  }
  // calls received api
  function callsReceivedFunc(vtoken, role, vendorId) {
    callsReceived(vtoken, role, vendorId).success(function (data) {
      $scope.allcallsReceived = data.data
      $scope.callsReceived = angular.copy($scope.allcallsReceived);
      $scope.clientName = [];
      $scope.email = [];
      $scope.phNo = [];
      $scope.callTime = [];
      if ($scope.callsReceived && $scope.callsReceived.length) {
        for (var i = 0; i < $scope.callsReceived.length; i++) {
          $scope.clientName.push($scope.callsReceived[i].name);
          $scope.email.push($scope.callsReceived[i].email);
          $scope.phNo.push($scope.callsReceived[i].phone);
          $scope.callTime.push($scope.callsReceived[i].created_on);
        }
      }
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    });
  }

  callsReceivedFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);

  function suggestionLeadsFunc(vtoken, role, vendorId) {
    suggestionLeads(vtoken, role, vendorId).success(function (data) {
      $scope.allSuggestionLeads = data.data;
      $scope.suggestionLeads = angular.copy($scope.allSuggestionLeads);
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    });
  }
  if ($scope.vendorData.role[0] != 'ROLE_BRAND_VENDOR') {
    suggestionLeadsFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
  }
  function bookingLeadsFunc(vtoken, role, vendorId) {
    bookingLeads(vtoken, role, vendorId).success(function (data) {
      $scope.allbookingLeads = data.data;
      $scope.bookingLeads = angular.copy($scope.allbookingLeads);
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    });
  }

  bookingLeadsFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
  // general enquiry api
  function generalEnquiryFunc(vtoken, role, vendorId) {
    generalEnquiry(vtoken, role, vendorId).success(function (data) {
      $scope.allGeneralEnquiry = data.data;
      $scope.generalEnquiry = angular.copy($scope.allGeneralEnquiry);
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    });
  }
  generalEnquiryFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
  //messages list api

  function messageReceivedFunc(vtoken, role, vendorId) {
    messageReceived(vtoken, role, vendorId).success(function (data) {
      $scope.allMessageLeads = data.data;
      $scope.messagesLeads = angular.copy($scope.allMessageLeads);
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    });
  }

  messageReceivedFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);

  // old quotes api
  function oldQuoteFunc(vtoken, role, vendorId) {
    oldQuote(vtoken, role, vendorId).then(function (data) {
      if (data.data) {
        console.log(data.data);
        $scope.allOldQuotes = data.data.data;
        $scope.oldQuotes = angular.copy($scope.allOldQuotes);
        $timeout(function () {
          $('.leadsScrollSection').perfectScrollbar('update')
        })
      }
    })
  }

  oldQuoteFunc(config.vtoken, $scope.vendorData.role[0], $scope.vendorId);
  // initializing daterangepicker
  // for leads section
  $scope.datePicker = {};
  $scope.datePicker.date = {
    startDate: null,
    endDate: null
  };
  // for calls received
  $scope.datePickerCr = {};
  $scope.datePickerCr.date = {
    startDate: null,
    endDate: null
  };
  // for view contacts
  $scope.datePickerVc = {};
  $scope.datePickerVc.date = {
    startDate: null,
    endDate: null
  };
  // for call mask
  $scope.datePickerCm = {};
  $scope.datePickerCm.date = {
    startDate: null,
    endDate: null
  };
  // for old quotes
  $scope.datePickeroq = {};
  $scope.datePickeroq.date = {
    startDate: null,
    endDate: null
  };

  //for booking leads
  $scope.datePickerBl = {};
  $scope.datePickerBl.date = {
    startDate: null,
    endDate: null
  };

  $scope.datePickerSl = {};
  $scope.datePickerSl.date = {
    startDate: null,
    endDate: null
  };
  //filtering datewise function
  $scope.dateFilterFunction = function (event, picker) {
    if ($scope.datePicker.date.startDate) {
      $scope.datePicker.date.unixStartDate = $scope.datePicker.date.startDate.unix();
      $scope.datePicker.date.unixEndDate = $scope.datePicker.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.messagesLeads = $scope.allMessageLeads.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.created_on);
        return (timestamp > $scope.datePicker.date.unixStartDate && timestamp < $scope.datePicker.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  };
  $scope.CrDateFilterFunction = function (event, picker) {
    if ($scope.datePickerCr.date.startDate) {
      $scope.datePickerCr.date.unixStartDate = $scope.datePickerCr.date.startDate.unix();
      $scope.datePickerCr.date.unixEndDate = $scope.datePickerCr.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.callsReceived = $scope.allcallsReceived.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.created_on);
        return (timestamp > $scope.datePickerCr.date.unixStartDate && timestamp < $scope.datePickerCr.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  };
  $scope.VcdateFilterFunction = function (event, picker) {
    if ($scope.datePickerVc.date.startDate) {
      $scope.datePickerVc.date.unixStartDate = $scope.datePickerVc.date.startDate.unix();
      $scope.datePickerVc.date.unixEndDate = $scope.datePickerVc.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.generalEnquiry = $scope.allGeneralEnquiry.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.created_on);
        return (timestamp > $scope.datePickerVc.date.unixStartDate && timestamp < $scope.datePickerVc.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  }

  $scope.CmdateFilterFunction = function (event, picker) {
    if ($scope.datePickerCm.date.startDate) {
      $scope.datePickerCm.date.unixStartDate = $scope.datePickerCm.date.startDate.unix();
      $scope.datePickerCm.date.unixEndDate = $scope.datePickerCm.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.callMasks = $scope.allCallMasks.filter(function (data) {
        var timestamp = angular.copy(data.call_start_timestap);
        return (timestamp > $scope.datePickerCm.date.unixStartDate && timestamp < $scope.datePickerCm.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  }

  $scope.BldateFilterFunction = function (event, picker) {
    if ($scope.datePickerBl.date.startDate) {
      $scope.datePickerBl.date.unixStartDate = $scope.datePickerBl.date.startDate.unix();
      $scope.datePickerBl.date.unixEndDate = $scope.datePickerBl.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.bookingLeads = $scope.allbookingLeads.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.created_on);
        return (timestamp > $scope.datePickerBl.date.unixStartDate && timestamp < $scope.datePickerBl.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  }

  $scope.SldateFilterFunction = function (event, picker) {
    if ($scope.datePickerSl.date.startDate) {
      $scope.datePickerSl.date.unixStartDate = $scope.datePickerSl.date.startDate.unix();
      $scope.datePickerSl.date.unixEndDate = $scope.datePickerSl.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.suggestionLeads = $scope.allSuggestionLeads.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.created_on);
        return (timestamp > $scope.datePickerSl.date.unixStartDate && timestamp < $scope.datePickerSl.date.unixEndDate)
      });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
    }
  }

  $scope.oqdateFilterFunction = function (event, picker) {
    if ($scope.datePickeroq.date.startDate) {
      $scope.datePickeroq.date.unixStartDate = $scope.datePickeroq.date.startDate.unix();
      $scope.datePickeroq.date.unixEndDate = $scope.datePickeroq.date.endDate.unix();
      //$scope.$apply(function() {
      $scope.oldQuotes = $scope.allOldQuotes.filter(function (data) {
        var timestamp = $scope.convertToTimestamp(data.quote_date + ' 00:00:00');
        return (timestamp > $scope.datePickeroq.date.unixStartDate && timestamp < $scope.datePickeroq.date.unixEndDate)
      });
      // $("#oldQuotesTbody").animate({
      //     scrollTop : $("#oldQuotesTbody").get(0).scrollHeight
      // });
      $timeout(function () {
        $('.leadsScrollSection').perfectScrollbar('update')
      })
      //});
    }
  }

  $scope.showDetailsClient = function (user_id, type) {
    if (type == 'vc') {
      vcDetail(config.vtoken, user_id, $scope.vendorData.role[0], $scope.vendorId).success(function (data) {
        $scope.generalEnquiryDetail = data.data.calls;
        $('#vcDetailModal').modal('toggle');
      })
    } else if (type == 'cr') {
      callHistory(config.vtoken, user_id, $scope.vendorData.role[0], $scope.vendorId).success(function (data) {
        $scope.callDetail = data.data.calls;
        $('#crDetailModal').modal('toggle');
        // $scope.callDetail = data.data.calls;
        //   $('#vcDetailModal').modal('toggle');
      })
    }
  }

  // function for sorting on the basis of select dropdown in enquiries tab
  $scope.applySelectFilter = function (sortFilterEnquiries) {
    $scope.messagesLeads = angular.copy($scope.allMessageLeads);
    if (sortFilterEnquiries == 0) {
      $scope.messagesLeads = $scope.messagesLeads.filter(function (value) {
        return Number(value.source) === 1;
      })
    }
    if (sortFilterEnquiries == 1) {
      $scope.messagesLeads = $scope.messagesLeads.filter(function (value) {
        return Number(value.source) === 2;
      })
    }
    if (sortFilterEnquiries == 2) {
      $scope.messagesLeads = $scope.messagesLeads.filter(function (value) {
        return Number(value.replied) === 1;
      })
    }
    if (sortFilterEnquiries == 3) {
      $scope.messagesLeads = $scope.messagesLeads.filter(function (value) {
        return Number(value.replied) === 0;
      })
    }
  }
  // sorting functionality for enquiries tab
  $scope.sortFilterEnqOptions = [{
    name: 'Messages from Web',
    value: 0,
    id: 0
  }, {
    name: 'Messages from App',
    value: 1,
    id: 1
  }, {
    name: 'Responded',
    value: 2,
    id: 2
  }, {
    name: 'Not Responded',
    value: 3,
    id: 3
  }];
  //function to  scroll viewport according to the tab clicked
  $scope.LeadsCatScroll = function (id, e) {
    $('.leads-section').find('div').css('color', 'grey')
    $(e.currentTarget).css('color', '#DE205E');
    jQuery('html, body').animate({
      scrollTop: jQuery(id).offset().top - 100
    }, 500);
  }
  //To redirect to the inbox messages with particular lead_id
  $scope.getMessage = function (message) {
    if (message.lead_type == 4) {
      $window.location.href = config.domain + '/vendor/feeds/message/' + message.lead_id;
    }
  }
}]);
vendorApp.controller('albumController', ['$scope', '$window', '$state', '$stateParams', 'config', 'getAlbumDetail', 'addNewAlbum', '$timeout', '$location', 'vendorData', 'getAllImages', 'postUpdateAlbum', 'postDeleteAlbum', 'ngDialog', 'albumOrder', function ($scope, $window, $state, $stateParams, config, getAlbumDetail, addNewAlbum, $timeout, $location, vendorData, getAllImages, postUpdateAlbum, postDeleteAlbum, ngDialog, albumOrder) {
  $scope.vendorData = vendorData.data.data;
  $scope.showAddAlbum;
  $scope.vendorStatus = $scope.vendorData.status;
  $scope.editButton = 0;
  $scope.addButton = 1;
  $scope.projectId;
  //console.log($scope.vendorStatus);
  if ($scope.vendorStatus === 'Y') {
    $scope.showAddAlbum = 1;
  } else {
    $scope.showAddAlbum = 0;
  }
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  if ($stateParams['r'] == 'true') {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  $scope.maxAlbum = "";
  var getAlbumFunction = function () {

    getAlbumDetail(config.vtoken).success(function (data) {
      data.data.albums.forEach(function (obj) {
        if (obj.thumb_status == 1) {
          var imageUrl = obj.cover_pic_url.replace('%%', '270');
          obj.actualImageUrl = imageUrl;
        } else {
          var imageUrl = obj.original_cover_pic_url;
          obj.actualImageUrl = imageUrl;
        }
      });
      $scope.albumInfo.albums = data.data.albums;
      $scope.maxAlbum = data.data.max_albums;
    });
  }
  getAlbumFunction();
  $scope.resetData = function () {
    $scope.albumTitle = "";
    $scope.albumLocation = "";
    $scope.albumDescription = "";
    $scope.editButton = 0;
    $scope.addButton = 1;
  }

  $scope.saveAlbum = function () {
    var addAlbumData = {
      project_name: $scope.albumTitle,
      location: $scope.albumLocation
    }
    if ($scope.albumDescription != undefined) {
      addAlbumData.description = $scope.albumDescription
    }
    addNewAlbum(config.vtoken, addAlbumData).success(function (data) {
      //$window.location.reload();
      $('#addAlbumModal').modal('hide');
      $('.modal-backdrop.in').css('display', 'none');
      $window.location.href = config.domain + '/vendor/feeds/image/' + data.data.section + '/' + data.data.id;
      //getAlbumFunction();
    })
  }
  $scope.editAlbum = function (data) {
    //console.log(data);
    getAllImages(config.vtoken, data.section, data.id).success(function (data) {
      //console.log(data);
      $scope.albumTitle = data.data.details.project_name;
      $scope.albumLocation = data.data.details.location;
      $scope.albumDescription = data.data.details.description;
      $scope.editButton = 1;
      $scope.addButton = 0;
      $scope.projectId = data.data.details.id;
      $('#addAlbumModal').modal('show');
    })
  }

  $scope.updateAlbum = function () {
    var updateAlbumData = {
      project_name: $scope.albumTitle,
      location: $scope.albumLocation,
      description: $scope.albumDescription,
      project_id: $scope.projectId
    }
    //console.log("albumInfo",updateAlbumData)
    postUpdateAlbum(config.vtoken, updateAlbumData).success(function (data) {
      getAlbumFunction();
      $('#addAlbumModal').modal('hide');
    })
  }

  $scope.delAlbum = function (album, event) {
    $scope.selectedId = [album.id, album.section, event];
    ngDialog.open({
      template: 'deleteAlbumId',
      scope: $scope,
      data: $scope.selectedId,
    })
  }

  $scope.sendRequest = function (id, section, event) {
    //console.log(id, section);
    var a = $(event.target).html();
    $(event.target).next().css('display', 'block');
    $(event.target).html('');
    //console.log("delete", image)
    postDeleteAlbum(config.vtoken, id, section).success(function (data) {
      //console.log("deleteResponse", data);
      $(event.target).next().css('display', 'none');
      $(event.target).html(a);

      //console.log("del",data);
      getAlbumFunction();
    })
  }

  $scope.getImages = function (section, id) {
    $window.location.href = config.domain + '/vendor/feeds/image/' + section + '/' + id;

  }


}]);
vendorApp.controller('membController', ['$scope', '$timeout', '$state', 'config', 'ngDialog', 'membershipPlans', 'changeMemb', 'vendorData', function ($scope, $timeout, $state, config, ngDialog, membershipPlans, changeMemb, vendorData) {
  $scope.S3_URL = config.S3_URL;
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  membershipPlans(config.vtoken).success(function (data) {
    $scope.membershipPlans = data.data.reverse();
    for (var i = 0; i < $scope.membershipPlans.length; i++) {
      if ($scope.membershipPlans[i].selected) {
        $scope.id_selected = $scope.membershipPlans[i].membership_id;
      }
      if ($scope.membershipPlans[i].selected && ($scope.membershipPlans[i].membership_id == 1 || $scope.membershipPlans[i].membership_id == 2)) {
        $scope.handfeatSelected = true;
      }
    }
    $scope.membershipPlans = $scope.membershipPlans.map(function (data) {
      if (data.price.indexOf('/') != -1) {
        var arr = data.price.split('/');
        data.price = arr[0];
        data.term = arr[1];
      }
      if (data.total && data.total.indexOf('/') != -1) {
        var arr = data.total.split('/');
        data.total = arr[0];
      }
      return data;
    });
    var arr = [];
    for (var k = 0; k < $scope.membershipPlans[0].features.length; k++) {
      arr[k] = [];
    }
    for (var i = 0; i < $scope.membershipPlans.length; i++) {
      for (var j = 0; j < $scope.membershipPlans[i].features.length; j++) {
        arr[j][i] = $scope.membershipPlans[i].features[j] + i;
      }
    }
    console.log(arr);
    $scope.arr = arr;
  });

  $scope.selectMembCat = function (id) {
    $scope.selectedId = [id];
    console.log($scope.selectedId);
    if ($scope.vendorData.status == 'N') {
      ngDialog.open({
        template: 'invalidStatusId',
        scope: $scope,
      })
    } else {
      ngDialog.open({
        template: 'selectTemplateId',
        scope: $scope,
        data: $scope.selectedId,
      })
    }
  }
  $scope.sendRequest = function (id) {
    changeMemb(config.vtoken, id).success(function (data) {
      if (id == 1) {
        $scope.membershipPlans[0].invited = 1;
      } else if (id == 2) {
        $scope.membershipPlans[1].invited = 1;
      } else if (id == 3) {
        $scope.membershipPlans[2].selected = 1;
      }
    })
  }
}]);
vendorApp.controller('membPlansController', ['$scope', '$state', '$location', '$timeout', 'packageSelection', 'cancelPackage', function ($scope, $state, $location, $timeout, packageSelection, cancelPackage) {
  $scope.membId = $location.search().memb;
  console.log(packageSelection, $scope.membId)
  localStorage.setItem('membership_id', $scope.membId);
  packageSelection($scope.membId).then(function (response) {
    $scope.membPlans = response.data.data;
    $scope.is_selected = false;
    $scope.membPlans = $scope.membPlans.map(function (data) {
      if (data.selected) {
        $scope.is_selected = true;
        $scope.id_selected = Number(data.id);
      }
      return data;
    })
  });
  $scope.selectPlan = function (e, plan) {
    console.log($scope.is_selected);
    if ($scope.is_selected == false) {
      var $that = $(e.target);
      $that.closest('#available-plans').find('.plan-selected-img').addClass('hide');
      $that.closest('.memb-plans-div').find('.plan-selected-img').removeClass('hide');
      $scope.id_selected = Number(plan.id);
    }
  }
  $scope.deselectPlan = function (e, plan) {
    var $that = $(e.target);
    // $that.closest('#available-plans').find('.memb-plans-div').removeClass('dashed-border-plans');
    // $that.closest('#available-plans').find('.memb-plans-div').removeClass('o-4');
    $that.closest('#available-plans').find('.deselect-icon').addClass('hide');
    cancelPackage(plan.id).then(function (response) {
      $scope.is_selected = false;
      $scope.id_selected = false;
      console.log(response);
    })

  }
  $scope.proceedPayment = function () {
    if ($scope.id_selected) {
      $('#select-plan').addClass('hide');
      $state.go('main.membChosen', { 'id': $scope.vendorId, 'plan': $scope.id_selected }, { reload: false });
    } else {
      $('#select-plan').toggleClass('hide');
    }
  }
}]);
vendorApp.controller('membChosenController', ['$scope', '$location', 'packageSelectionDet', 'membPayNow', 'config', function ($scope, $location, packageSelectionDet, membPayNow, config) {
  $scope.id_selected = $location.search().plan;
  $scope.memb_id = localStorage.getItem('membership_id');
  localStorage.setItem('package_id', $scope.id_selected);
  $scope.taxAndTotal = {};
  packageSelectionDet($scope.id_selected).then(function (response) {
    console.log(response);
    $scope.planData = response.data.data;
    $scope.newData = {};
    console.log($scope.planData);
    for (var key in $scope.planData) {
      if (key == 'order_id') {
        $scope.order_id = $scope.planData[key];
        $scope.payNowUrl = config.domain + '/api/v1/vendor/membership/payment?version=1.1&token=' + config.vtoken + '&order_id=' + $scope.order_id
      }
      if (key == 'tax_percentage') {
        $scope.tax_percentage = $scope.planData[key];
      }
      $scope.order_id = $scope.planData['visible_order_id'];
      if (key != 'duration' && key != 'subtotal' && key != 'visible_order_id' && key != 'total' && key != 'tax_price' && key != 'discount_price') {
        delete $scope.planData[key];
      }
      if (key == 'discount_price' && !$scope.planData[key]) {
        delete $scope.planData[key];
      }
    }

    if ($scope.planData['total'] != null) {
      //var discount = Number($scope.planData['subtotal']) - Number($scope.planData['total']);
      var total = $scope.planData['total'];
      delete $scope.planData['total'];
      //$scope.planData['Discount'] = discount;
      $scope.planData['total'] = total;
    }
    $scope.newData['Package_Price'] = $scope.planData['subtotal'];
    //$scope.newData['Discount'] = $scope.planData['Discount'];
    $scope.newData['Discount'] = $scope.planData['discount_price'];
    if ($scope.newData['Discount']) {
      var newTotal = Number($scope.planData['subtotal']) - Number($scope.planData['discount_price']);
      $scope.newData['discounted_price'] = newTotal;
    }
    $scope.newData['gst_tax'] = $scope.planData['tax_price'];
    $scope.newData['total'] = $scope.planData['total'];
    console.log($scope.planData);
  });
  // $scope.payNow = function() {
  //   membPayNow($scope.order_id).then(function(response) {
  //     console.log(response);
  //   })
  // }
}]);
vendorApp.controller('membResponseController', ['$scope', 'paymentStatus', '$location', function ($scope, paymentStatus, $location) {
  var order_id = $location.search().order_id;
  localStorage.setItem('order_id', order_id);
  function getMonthText(month) {
    console.log(month)
    switch (month) {
      case 0:
        month = 'Jan';
        break;
      case 1:
        month = 'Feb';
        break;
      case 2:
        month = 'Mar';
        break;
      case 3:
        month = 'Apr';
        break;
      case 4:
        month = 'May';
        break;
      case 5:
        month = 'Jun';
        break;
      case 6:
        month = 'Jul';
        break;
      case 7:
        month = 'Aug';
        break;
      case 8:
        month = 'Sept';
        break;
      case 9:
        month = 'Oct';
        break;
      case 10:
        month = 'Nov';
        break;
      case 11:
        month = 'Dec';
        break;
    }
    return month;
  }
  paymentStatus(order_id).then(function (response) {
    if (response.data.data.status == "SUCCESS") {
      $('.payment-success').removeClass('hide');
    } else {
      $('.payment-failure').removeClass('hide');
      delete response.data.data['amount'];
    }
    for (var key in response.data.data) {
      //key = key.capitalizeFirstLetter;
      if (key == 'package_id') {
        $scope.package_id = response.data.data[key];
        delete response.data.data[key];
      }
      if (key == 'start_date') {
        var date = new Date(response.data.data[key]);
        var year = date.getFullYear();
        var month = getMonthText(date.getMonth());
        var day = date.getDate();
        response.data.data[key] = day + '-' + month + '-' + year;
      }
      if (key == 'end_date') {
        var date = new Date(response.data.data[key]);
        var year = date.getFullYear();
        var month = getMonthText(date.getMonth());
        var day = date.getDate();
        response.data.data[key] = day + '-' + month + '-' + year;
      }
      if (key == 'status') {
        console.log(key);
        delete response.data.data[key]
      }
    }
    $scope.statusData = response.data.data;
    console.log($scope.statusData);
    // $scope.statusData = $scope.statusData.map(function(data) {
    //   data
    // })
  })
}])
vendorApp.directive('dateRangePicker', function ($filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
      function formatter(input) {
        if (input) {
          var arr = [];
          var newArr = [];
          var arr1 = [];
          arr = input.split('-');
          newArr[0] = arr[0] + '-' + arr[1] + '-' + arr[2];
          newArr[1] = arr[3] + '-' + arr[4] + '-' + arr[5];
          newArr[0] = $filter('datemonth')(newArr[0], 'dateRange');
          newArr[1] = $filter('datemonth')(newArr[1], 'dateRange');
          arr = newArr[0].split('-');
          arr1 = newArr[1].split('-');
          input = arr[0] + ' ' + arr[1] + '-' + arr1[0] + ' ' + arr1[1];
          return input;
        } else {
          return '';
        }
      }
      ngModelCtrl.$formatters.push(formatter);
    }
  }
});
vendorApp.directive('multiInput', function ($timeout) {
  return {
    restrict: 'AE',
    templateUrl: '../../html/multiInput.html',
    // scope: {
    //     faq: '=',
    //     arr: '@',
    // },
    link: function (scope, element, attrs) {
      scope.faq = scope.$eval(attrs.faq);
      scope.faqArr = scope.$eval(attrs.arr);

      $timeout(function () {
        $('input.faq-number').bind({
          keydown: function (e) {
            if (e.keyCode == 190 || e.keyCode == 69 || e.keyCode == 189) {
              return false;
            }
          }
        })
      })

      scope.showChildFaq = function (e) {
        if (e.target.tagName == "INPUT") {
            
          if ($(e.target).closest('.checkbox-options').find('.child-multi-select').hasClass('d-n')) {
            $(e.target).closest('.checkbox-options').find('.child-multi-select').removeClass('d-n');
            // for rendering slider view according to value
            scope.$broadcast('reCalcViewDimensions');
          } else {
            $(e.target).closest('.checkbox-options').find('.child-multi-select').addClass('d-n')
          }

          var elementsFifth = document.getElementsByClassName("req-pr-cha-slider");


                var openPriceChangeModalFifth = function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var id = this.getAttribute("data-attribute-id");
                    angular.element(angular.element('.modal-fifth[data-attribute-id="' + id + '"]')[0]).modal('show');
                };

                for (var i = 0; i < elementsFifth.length; i++) {
                    elementsFifth[i].addEventListener('click', openPriceChangeModalFifth, false);
                }

                var elementsFourth = document.getElementsByClassName("element-fourth");

                var openPriceChangeModalFourthElem = function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var id = this.getAttribute("data-attribute-id");
                    angular.element(angular.element('.modal-fourth[data-attribute-id="' + id + '"]')[0]).modal('show');
                };

                for (var i = 0; i < elementsFourth.length; i++) {
                    elementsFourth[i].addEventListener('click', openPriceChangeModalFourthElem, false);
                }

                var elementsThird = document.getElementsByClassName("element-third");

                var openPriceChangeModalThirdElem = function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var id = this.getAttribute("data-attribute-id");
                    angular.element(angular.element('.modal-third[data-attribute-id="' + id + '"]')[0]).modal('show');
                };

                for (var i = 0; i < elementsThird.length; i++) {
                    elementsThird[i].addEventListener('click', openPriceChangeModalThirdElem, false);
                }

                var elementsSecond = document.getElementsByClassName("element-second");

                var openPriceChangeModalSecondElem = function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var id = this.getAttribute("data-attribute-id");
                    angular.element(angular.element('.modal-second[data-attribute-id="' + id + '"]')[0]).modal('show');
                };

                for (var i = 0; i < elementsSecond.length; i++) {
                    elementsSecond[i].addEventListener('click', openPriceChangeModalSecondElem, false);
                }

                var elementsFirst = document.getElementsByClassName("element-first");
                var openPriceChangeModalFirstElem = function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var id = this.getAttribute("data-attribute-id");
                    angular.element(angular.element('.modal-first[data-attribute-id="' + id + '"]')[0]).modal('show');
                };

                for (var i = 0; i < elementsFirst.length; i++) {
                    elementsFirst[i].addEventListener('click', openPriceChangeModalFirstElem, false);
                }
        }
      }
    }
  }
});

vendorApp.directive('membershipPlanBox', function ($timeout, ngDialog, config, changeMemb) {
  return {
    restrict: 'E',
    templateUrl: '../../html/membershipPlanBox.html?v=1.0.2',
    scope: {
      planType: "=",
      costStrikeThrough: "=",
      free: "=",
      planCost: "@",
      planValidity: "@",
      membId: "=",
      vendorId: "=",
      removeColMd: '=',
      plan: '=',
      index: '=',
      first: '=',
      last: '=',
      idSelected: '=',
      status: '=',
      s3: '='
    },

    link: function (scope, element, attrs) {
      scope.selectMembCat = function (id) {
        if (id == 3) {
          return;
        }
        scope.selectedId = [id];
        if (scope.status == 'N') {
          ngDialog.open({
            template: 'invalidStatusId',
            scope: scope,
          })
        } else {
          ngDialog.open({
            template: 'selectTemplateId',
            scope: scope,
            data: scope.selectedId,
          })
        }
      }
      scope.sendRequest = function (id) {
        changeMemb(config.vtoken, id).then(function (data) {
          window.location.reload();
        })
      }
    }
  }
});

vendorApp.directive('multiSelect', function ($compile, RecursionHelper) {
  return {
    restrict: 'A',
    template: '<div></div>',
    scope: {
      option: '='
    },
    link: function (scope, element, attrs) {
      if ((scope.option && (scope.option.child != '' || !scope.option.child || scope.option.child != '0'))) {
        element.append('<div ng-repeat="child in option.children">' +
          '<div multi-input faq="child">' +
          '</div>' +
          '</div>');
        $compile(element.contents())(scope)
      }
    }
  }
});

vendorApp.controller('reviewController', ['$scope', '$location', '$anchorScroll', '$timeout', '$state', 'config', 'getReviewList', 'postPinToTopVendorReview', 'postReviewMessage', 'vendorData', function ($scope, $location, $anchorScroll, $timeout, $state, config, getReviewList, postPinToTopVendorReview, postReviewMessage, vendorData) {
  $scope.vendorData = vendorData.data.data;
  $scope.vendorData.membershipId = vendorData.data.data.membership_id;
  $scope.has_pin_to_top = $scope.vendorData.has_pin_to_top_review;
  $scope.canReply = true;
  $scope.reviewInfo = {};
  $scope.reviewButton = [];
  $scope.blankMesaage = [];
  $scope.review = {};
  $scope, stickers = [];
  //console.log("review",config.vtoken);
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  getReviewList(config.vtoken).success(function (data) {
    //console.log("getReviewList",data);
    if (data.data) {
      $scope.emptyReview = 0;
      $scope.reviewInfo = data.data;
      for (var i = 0; i < data.data.length; i++) {
        $scope.reviewButton[i] = {};
        $scope.reviewButton[i].id = i;
        $scope.reviewInfo[i].reviewMessage = data.data[i].comment;
        $scope.reviewButton[i].reviewReply = data.data[i].comment == null ? 'Reply' : 'Edit';
      }
    } else {
      $scope.emptyReview = 1;
    }
  })

  $scope.pinToTop = function (review, index) {
    postPinToTopVendorReview(config.vtoken, review.id).success(function (data) {
      $state.reload();
      $anchorScroll();
    });
  }


  $scope.replyReview = function (review, reviewButton, index) {
    //console.log(review, $scope.reviewInfo[index].reviewMessage,index,reviewButton[index].reviewReply, $scope.reviewButton[index].reviewReply);
    if (reviewButton[index].reviewReply === "Reply") {
      //console.log(review, $scope.reviewInfo.reviewMessage,reviewReply);
      postReviewMessage(config.vtoken, review.id, $scope.reviewInfo[index].reviewMessage).success(function (data) {
        if (data.data == "errors.data_missing") {
          $scope.reviewButton[index].reviewReply = 'Reply'
          $scope.blankMesaage[index] = 1;
        } else {
          $scope.reviewButton[index].reviewReply = 'Edit'
          $scope.blankMesaage[index] = 0;
        }
        //console.log("comment", $scope.reviewButton[index].reviewReply,data);
      });
    } else if (reviewButton[index].reviewReply === "Edit") {
      $scope.reviewButton[index].reviewReply = 'Reply'
      //console.log("comment", $scope.reviewButton[index].reviewReply);
    }

  }
  $scope.textAreaExpand = function (event, index) {
    //console.log("keyup",event, $scope.reviewInfo[index].reviewMessage,event.target.attributes.rows.value, $scope.reviewInfo[index].reviewMessage.length);
    var tshc = event.target.scrollHeight;
    //console.log("height",tsh);
    if (tshc < 112) {
      $(event.target).css('overflow', 'hidden')
      $(event.target).css('height', 0);
      var tsh = event.target.scrollHeight + 'px';
      $(event.target).css('height', tsh);
    } else {
      $(event.target).css('overflow', 'auto')
    }
    /*this.style.overflow = 'hidden';
    this.style.height = 0;
    this.style.height = this.scrollHeight + 'px';*/
  }
}]);

vendorApp.controller('vendorInboxController', ['$scope', '$window', '$timeout', '$state', 'config', 'vendorData', 'getAllMessage', '$location', function ($scope, $window, $timeout, $state, config, vendorData, getAllMessage, $location) {
  $scope.messageDetail = {};
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  getAllMessage(config.vtoken).success(function (data) {
    //console.log("vendorInbox",data,config.vtoken);
    if (data.data) {
      $scope.emptyInbox = 0;
      data.data.forEach(function (obj) {
        var senderId = obj.sender_id;
        obj.users.forEach(function (user) {
          var memberId = user.member_id;
          if (senderId == memberId) {
            var imageUrl = user.profile_pic_url;
            obj.actualImageUrl = imageUrl.replace('%%', '270');
          }

        })
        //console.log("obj",user,senderId);
      })
      $scope.messageDetail = data.data;
      //console.log("vendorInboxController", $scope.messageDetail);
    } else {
      $scope.emptyInbox = 1;
    }
  })
  $scope.getMessage = function (message) {
    //console.log("message",message)
    $window.location.href = config.domain + '/vendor/feeds/message/' + message.thread_id;
  }
}]);

vendorApp.controller('MenuController', ['$scope', '$location', '$sce', '$timeout', '$state', 'config', 'Upload', 'saveMenu', 'getMenu', 'ngDialog', 'deleteMenu', 'getMenus', 'deleteMenuFile', 'vendorData', function ($scope, $location, $sce, $timeout, $state, config, Upload, saveMenu, getMenu, ngDialog, deleteMenu, getMenus, deleteMenuFile, vendorData) {
  $scope.menu = {};
  $scope.menus = {};
  $scope.numArray = [];
  $scope.menu.starters = 'Starters';
  $scope.menu.mainCourse = 'Main Course';
  $scope.menu.appetisers = 'Appetisers';
  $scope.menu.desserts = 'Desserts';
  $scope.menu.menuType = 'Type';
  $scope.menuSentDisable = false;
  $scope.selectedNonVeg = false;
  $scope.menus.menuFiles = []

  var location_params = $location.search()
  var vendor_id = $location.search().id;

  for (var i = 1; i <= 20; i++) {
    $scope.numArray.push(i);
  }

  $('#menuModal').on('hidden.bs.modal', function () {
    $scope.menuForm.$setPristine();
    $scope.menu = {};
  })

  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }

  $scope.openMmodal = function () {
    if ($scope.menus && $scope.menus.menu_desc_types) {
      $scope.menu.starters = $scope.menus.menu_desc_types.starters;
      $scope.menu.mainCourse = $scope.menus.menu_desc_types.main_course;
      $scope.menu.appetisers = $scope.menus.menu_desc_types.appetisers;
      $scope.menu.desserts = $scope.menus.menu_desc_types.desserts;
      $scope.menu.non_veg_starter = $scope.menus.menu_desc_types.non_veg_starter;
      $scope.menu.non_veg_maincourse = $scope.menus.menu_desc_types.non_veg_maincourse;
      $scope.menu.non_veg_appetiser = $scope.menus.menu_desc_types.non_veg_appetiser;
      $scope.menu.non_veg_dessert = $scope.menus.menu_desc_types.non_veg_dessert;
      $scope.menu.menuType = 'Type';
    }
    $('#menuModal').modal('toggle');
    $scope.menuForm.$setPristine();
  }

  $scope.openMenuModal = function (e, url, type) {
    //e.preventDefault();
    if (type == 'pdf') {
      $scope.pdf = true;
      $scope.menuModalUrl = $sce.trustAsResourceUrl('http://docs.google.com/gview?url=' + url + '&output=embed');
    } else {
      $scope.pdf = false;
      $scope.menuModalUrl = url
    }
    $('#menuFileModal').modal('toggle');
  }

  $scope.$watchCollection('menu', function (data) {
    //console.log(data.menuType);
    if ($scope.menu.starters != 'Starters' && $scope.menu.mainCourse != 'Main Course' && $scope.menu.appetisers != 'Appetisers' && $scope.menu.desserts != 'Desserts') {
      $('#menuDesc').css('display', 'none');
    }
    if ($scope.menu.menuType != 'Type') {
      $('#menuType').css('display', 'none');
    }
    if (data.menuType == '3' || data.menuType == '4') {
      $scope.selectedNonVeg = true;
    } else {
      $scope.selectedNonVeg = false;
    }
  })

  var loadMenu = function () {
    getMenu(config.vtoken, location_params.id).success(function (data) {
      //console.log(data);
      $scope.menus.menuData = data.data;
      $scope.menus.menu_desc_types = angular.copy(data.menu_desc_types);
    })
  }

  loadMenu();

  var loadMenus = function (file) {
    getMenus(vendor_id).success(function (data) {
      $scope.menus.menuFiles = data.data || [];
      if (file) {
        file.loader = 0;
      }
      angular.forEach($scope.menus.menuFiles, function (value) {
        if (value.ext == 'pdf') {
          value.menu_url = $sce.trustAsResourceUrl('http://docs.google.com/gview?url=' + value.menu_url + '&embedded=true');
        }
      })
    })
  }

  loadMenus();

  $scope.deletethisMenu = function (id, type) {
    //console.log(id)
    if (type == 'file') {
      deleteMenuFile(config.vtoken, vendor_id, id).success(function (data) {
        loadMenus();
      });
    } else {
      deleteMenu(config.vtoken, vendor_id, id).success(function (data) {
        loadMenu();
      });
    }
  }

  $scope.deleteMenu = function (id, type) {
    //console.log(id);
    $scope.selectedId = [id, type];
    ngDialog.open({
      template: 'deleteMeId',
      scope: $scope,
      data: $scope.selectedId,
    })
  }

  $scope.editMenu = function (id) {
    var menu = $scope.menus.menuData.filter(function (menu) {
      return menu.id == id;
    });
    //console.log(menu[0]);
    $scope.menu.title = menu[0].title;
    $scope.menu.menuType = menu[0].menu_type_id || menu[0].menu_type;
    $scope.menu.price = Number(menu[0].price_per_plate);
    $scope.menu.starters = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.starters) || $scope.menus.menu_desc_types.starters) : $scope.menus.menu_desc_types.starters;
    $scope.menu.mainCourse = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.main_course) || $scope.menus.menu_desc_types.main_course) : $scope.menus.menu_desc_types.main_course;
    $scope.menu.appetisers = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.appetisers) || $scope.menus.menu_desc_types.appetisers) : $scope.menus.menu_desc_types.appetisers;
    $scope.menu.desserts = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.desserts) || $scope.menus.menu_desc_types.desserts) : $scope.menus.menu_desc_types.desserts;
    $scope.menu.non_veg_starter = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.non_veg_starter) || $scope.menus.menu_desc_types.non_veg_starter) : $scope.menus.menu_desc_types.non_veg_starter;
    $scope.menu.non_veg_maincourse = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.non_veg_maincourse) || $scope.menus.menu_desc_types.non_veg_maincourse) : $scope.menus.menu_desc_types.non_veg_maincourse;
    $scope.menu.non_veg_appetiser = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.non_veg_appetiser) || $scope.menus.menu_desc_types.non_veg_appetiser) : $scope.menus.menu_desc_types.non_veg_appetiser;
    $scope.menu.non_veg_dessert = angular.copy(menu[0].desc) ? (angular.copy(menu[0].desc.non_veg_dessert) || $scope.menus.menu_desc_types.non_veg_dessert) : $scope.menus.menu_desc_types.non_veg_dessert;
    $scope.menu.id = id;
    $('#menuModal').modal('toggle');
  }
  var wrongUpload = false;
  $scope.uploadMenu = function (files, errFiles) {
    //console.log(files);
    //console.log(errFiles);
    wrongUpload = false;
    //$('#imageTypeErr').css('display','none');
    if (!files) {
      return;
    }
    //console.log(files);
    if (files) {
      $('.addnMenu').css('display', 'none')
      $scope.files = files;
      var fileLength = $scope.files.length;
      var count = 0;
      angular.forEach(files, function (file) {
        file.loader = 1;
        $scope.menus.menuFiles.push(file);
        $scope.fileName = file.name;
        $scope.menu.menuFile = file;
        Upload.upload({
          url: config.domain + '/api/v1/venue/post/menu_files?version=1.1&token=' + config.vtoken + '&vendor_id=' + location_params.id,
          data: {
            menu_file: [file]
          }
        }).success(function (data) {
          loadMenus(file);
          count++;
          if (count == fileLength) {
            $('.addnMenu').css('display', 'block')
          }
        })
      })
    }
  }
  $scope.submitMenu = function (menu) {
    $('#imagerequired').css('display', 'none');
    $('#menuDesc').css('display', 'none');
    $('#menuType').css('display', 'none');
    var errCount = 0;

    if ($('form[name="menuForm"').hasClass('ng-invalid')) {
      errCount++;
    }
    if ($scope.menu.menuType === 'Type') {
      $('#menuType').css('display', 'block');
      errCount++;
    }
    if (errCount > 0) {
      return;
    }
    if (menu.starters == $scope.menus.menu_desc_types.starters) {
      delete menu.starters
    }
    if (menu.mainCourse == $scope.menus.menu_desc_types.main_course) {
      delete menu.mainCourse;
    }
    if (menu.appetisers == $scope.menus.menu_desc_types.appetisers) {
      delete menu.appetisers;
    }
    if (menu.desserts == $scope.menus.menu_desc_types.desserts) {
      delete menu.desserts;
    }
    if (menu.non_veg_starter == $scope.menus.menu_desc_types.non_veg_starter) {
      delete menu.non_veg_starter;
    }
    if (menu.non_veg_maincourse == $scope.menus.menu_desc_types.non_veg_maincourse) {
      delete menu.non_veg_maincourse;
    }
    if (menu.non_veg_appetiser == $scope.menus.menu_desc_types.non_veg_appetiser) {
      delete menu.non_veg_appetiser;
    }
    if (menu.non_veg_dessert == $scope.menus.menu_desc_types.non_veg_dessert) {
      delete menu.non_veg_dessert;
    }
    if ($scope.menu.id) {
      menu.id = $scope.menu.id;
    }
    $('.submit-button-v').html('');
    $('.invite-spin').css('display', 'block');
    $scope.menuSentDisable = true

    saveMenu(config.vtoken, location_params.id, menu).success(function (data) {
      $('.submit-button-v').html('SUBMIT');
      $('.invite-spin').css('display', 'none');
      $('#menuModal').modal('toggle');
      $scope.menuSentDisable = false;
      loadMenu();
    })
  }
}]);

vendorApp.controller('banquetsController', ['$scope', '$location', '$timeout', '$state', 'addBanquet', 'config', 'getBanquet', 'deleteBanquet', 'ngDialog', 'vendorData', function ($scope, $location, $timeout, $state, addBanquet, config, getBanquet, deleteBanquet, ngDialog, vendorData) {
  $scope.banquets = {};
  var vendor_id = $location.search().id;
  $scope.banquet = {}
  $scope.venueSentDisable = false;
  //console.log(location_params);

  $('#banquetModal').on('hidden.bs.modal', function () {
    $scope.banquet = {}
  });

  // $('#banquetModal').on('shown.bs.modal', function () {
  //   console.log('showing');
  //     $scope.banquetForm.$setPristine();
  // });

  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }

  $scope.openBmodal = function () {
    //console.log('showing');
    $('#banquetModal').modal('toggle');
    $scope.banquetForm.$setPristine();
  }

  getBanquet(config.vtoken, vendor_id).success(function (data) {
    $scope.banquets.banquetData = data.data;
  });

  $scope.addBanquet = function (banquets) {

    if ($('form[name="banquetForm"').hasClass('ng-invalid')) {
      return;
    }
    $('.submit-button-v').html('');
    $('.invite-spin').css('display', 'block');
    $scope.venueSentDisable = true
    addBanquet(config.vtoken, vendor_id, banquets).success(function () {
      $('#banquetModal').modal('toggle');
      $('.submit-button-v').html('SUBMIT');
      $('.invite-spin').css('display', 'none');
      $scope.venueSentDisable = false;
      getBanquet(config.vtoken, vendor_id).success(function (data) {
        $scope.banquets.banquetData = data.data;
      });
    })
  }

  $scope.deletethisBanquet = function (id) {
    deleteBanquet(config.vtoken, vendor_id, id).success(function (data) {
      getBanquet(config.vtoken, vendor_id).success(function (data) {
        $scope.banquets.banquetData = data.data;
      });
    });
  }

  $scope.editBanquet = function (id) {
    var banquet = $scope.banquets.banquetData.filter(function (banquet) {
      return banquet.id == id
    });
    $scope.banquet.title = banquet[0].title;
    $scope.banquet.fixed_capacity = Number(banquet[0].fixed_capacity);
    $scope.banquet.floating_capacity = Number(banquet[0].floating_capacity);
    $scope.banquet.indoor_outdoor = banquet[0].indoor_outdoor;
    $scope.banquet.id = id;
    $('#banquetModal').modal('toggle');
  }

  $scope.deleteBanquet = function (id) {
    $scope.selectedId = [id];
    ngDialog.open({
      template: 'deleteBaId',
      scope: $scope,
      data: $scope.selectedId,
    })
  }
}]);

vendorApp.controller('bookingController', ['$scope', '$timeout', '$state', 'config', 'getVendorBooking', 'vendorData', function ($scope, $timeout, $state, config, getVendorBooking, vendorData) {
  $scope.S3_URL = config.S3_URL;
  $scope.bookings = {}
  $scope.domain = config.domain;
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }

  console.log('qwertyasdm1234567');

  $scope.getDetails = function (isComplete) {
    if (isComplete == 0) {
      $("#incomplete").addClass("active-tab");
      $("#complete").removeClass("active-tab");
    }
    else if (isComplete == 1) {
      $("#complete").addClass("active-tab");
      $("#incomplete").removeClass("active-tab");
    }
    getVendorBooking(config.vtoken, isComplete)
      .then(function (response) {
        if (response.status == 204) {
          $scope.bookings.bookingData = {};
          $('.failure-container').css('display', 'block');
          return;
        }
        if (response.data !== '') {
          $('#info-section').css('display', 'block');
          $('.failure-container').css('display', 'none');
          $scope.bookings.bookingData = angular.copy(response.data.data);
        }
      })
      .catch(function (err) {
        console.log(err);
        $('.failure-container').css('display', 'block');
      });
  }

  $scope.getDetails(0);

}]);

vendorApp.controller('bookingDetailController', ['$http', '$scope', '$location', '$rootScope', 'config', '$state', '$stateParams', 'userBookingDetail', 'userBookingDetailNew', 'postAcceptPrice', 'ngDialog', '$timeout', 'ngToast', 'vendorData', function ($http, $scope, $location, $rootScope, config, $state, $stateParams, userBookingDetail, userBookingDetailNew, postAcceptPrice, ngDialog, $timeout, ngToast, vendorData) {
  $scope.leadId = $stateParams.detailId;
  console.log($state);
  console.log($location.search());
  $scope.is_new = $location.search().is_new;
  $scope.booking_hash = $location.search().booking_hash;
  $scope.userBookingDetailData = {};
  $scope.checkoutData = {};
  $scope.flag = 0;
  $scope.vendorDetail = {};
  $scope.priceFlag = 0;
  $scope.addOnFunction = {};
  $scope.mainFunction = {};
  $scope.totalFunction = {};
  $scope.furtherDiscountValue;
  $scope.extraTextValue;

  // function userBookingAPICall(tok, lId, b_hash){
  // 	console.log("function called", tok, lId, b_hash);
  // 	userBookingDetailNew(tok, lId, b_hash)
  // 	.then(function(data){
  // 		if(data.data.data.status_text){
  // 			$scope.status_text = data.data.data.status_text;
  // 			console.log($scope.status_text);
  // 			var statusText = $scope.status_text;
  // 			if(statusText.indexOf("|") >= 0) {
  // 				var StatusArray = statusText.split('|');
  // 				$scope.status1 = StatusArray[0];
  // 				$scope.status2 = StatusArray[1];
  // 				$scope.flag = 1;
  // 			}
  // 		}
  // 		$scope.userBookingDetailData.detail = data.data.data;
  // 		$scope.checkoutData.function_box = data.data.data.function_box;
  // 		$scope.checkoutData.add_on_service = data.data.data.add_on_service;
  // 		$scope.vendorDetail.Step3 = data.data.data.pricing_breakup;
  // 		$scope.addOnFunction = data.data.data.pricing_breakup.addon_breakup;
  // 		$scope.mainFunction = data.data.data.pricing_breakup.service_breakup;
  // 		$scope.totalFunction = data.data.data.services;
  // 		$scope.finalPrice = $scope.userBookingDetailData.detail.price_quote;
  // 		$scope.answer = $scope.userBookingDetailData.detail.user_preference ? ($scope.userBookingDetailData.detail.user_preference[0].answer_value == "1" ? 'Yes' : 'No') : "";
  // 		$scope.initialPrice = $scope.userBookingDetailData.detail.original_price;
  // 		$scope.priceFlag = $scope.finalPrice == $scope.initialPrice ? 0 : 1;
  // 		if($scope.checkoutData.add_on_service && $scope.checkoutData.add_on_service.length) {
  // 			$scope.vendorDetail.Step3.addon_breakup.forEach(function (obj) {
  // 				$scope.checkoutData.add_on_service.forEach(function (extraObj) {
  // 					if((extraObj.id == '5' && obj.service_id == '5') || (extraObj.id == '10' && obj.service_id == '10')) {
  // 						extraObj.count = obj.count;
  // 					}
  // 				})
  // 			});
  // 		}
  // 		if((!localStorage.getItem('vendor_logged_in'))){
  // 			localStorage.setItem("vendor_logged_in", true);
  // 			$state.reload();
  // 		}
  // 	})
  // 	.catch(function(err){
  // 		console.log(err);
  // 	});
  // }

  if (vendorData.data.data && vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  $scope.userBookingDetailFunc = function () {
    console.log('userBookingDetailFunc called', $rootScope.is_new);
    $scope.flag = 0;

    if ($scope.is_new == 0) {
      userBookingDetail(config.vtoken, $scope.leadId).success(function (data) {
        console.log(data);
        if (data.data.status_text) $scope.status_text = data.data.status_text;
        $scope.userBookingDetailData.detail = data.data;
        $scope.checkoutData.function_box = data.data.function_box;
        $scope.checkoutData.add_on_service = data.data.add_on_service;
        $scope.vendorDetail.Step3 = data.data.pricing_breakup;
        $scope.addOnFunction = data.data.pricing_breakup.addon_breakup;
        $scope.mainFunction = data.data.pricing_breakup.service_breakup;
        $scope.totalFunction = data.data.services;
        $scope.finalPrice = $scope.userBookingDetailData.detail.price_quote;
        $scope.answer = $scope.userBookingDetailData.detail.user_preference ? ($scope.userBookingDetailData.detail.user_preference[0].answer_value == "1" ? 'Yes' : 'No') : "";
        $scope.initialPrice = $scope.userBookingDetailData.detail.original_price;
        $scope.priceFlag = $scope.finalPrice == $scope.initialPrice ? 0 : 1;
        var statusText = $scope.status_text;
        if (statusText.indexOf("|") >= 0) {
          var StatusArray = statusText.split('|');
          $scope.status1 = StatusArray[0];
          $scope.status2 = StatusArray[1];
          $scope.flag = 1;
        }
        $scope.vendorDetail.Step3.service_breakup.forEach(function (obj) {
          $scope.totalFunction.forEach(function (extraObj) {
            if (obj.service_id == extraObj.id) {
              obj.service_name = extraObj.service_offered
            }
          })
        });
        if ($scope.vendorDetail.Step3.addon_breakup && $scope.vendorDetail.Step3.addon_breakup.length) {
          $scope.vendorDetail.Step3.addon_breakup.forEach(function (obj) {
            $scope.totalFunction.forEach(function (extraObj) {
              if (obj.service_id == extraObj.id) {
                obj.service_name = extraObj.service_offered
              }
              if (extraObj.service_id == '5') {
                obj.count = extraObj.count;
              }
            })
          });
        }
        if ($scope.checkoutData.add_on_service && $scope.checkoutData.add_on_service.length) {
          $scope.vendorDetail.Step3.addon_breakup.forEach(function (obj) {
            $scope.checkoutData.add_on_service.forEach(function (extraObj) {
              if ((extraObj.id == '5' && obj.service_id == '5') || (extraObj.id == '10' && obj.service_id == '10')) {
                extraObj.count = obj.count;
              }
            })
          });
        }
      });
    }
    else if ($scope.is_new == 1) {
      console.log('when is_new 1', config.vtoken, $scope.leadId, $scope.booking_hash);
      userBookingDetailNew(config.vtoken, $scope.leadId, $scope.booking_hash)
        .then(function (data) {
          if (data.data.data.status_text) {
            $scope.status_text = data.data.data.status_text;
            console.log($scope.status_text);
            var statusText = $scope.status_text;
            if (statusText.indexOf("|") >= 0) {
              var StatusArray = statusText.split('|');
              $scope.status1 = StatusArray[0];
              $scope.status2 = StatusArray[1];
              $scope.flag = 1;
            }
          }
          $scope.userBookingDetailData.detail = data.data.data;
          $scope.checkoutData.function_box = data.data.data.function_box;
          $scope.checkoutData.add_on_service = data.data.data.add_on_service;
          $scope.vendorDetail.Step3 = data.data.data.pricing_breakup;
          $scope.addOnFunction = data.data.data.pricing_breakup.addon_breakup;
          $scope.mainFunction = data.data.data.pricing_breakup.service_breakup;
          $scope.totalFunction = data.data.data.services;
          $scope.finalPrice = $scope.userBookingDetailData.detail.price_quote;
          $scope.answer = $scope.userBookingDetailData.detail.user_preference ? ($scope.userBookingDetailData.detail.user_preference[0].answer_value == "1" ? 'Yes' : 'No') : "";
          $scope.initialPrice = $scope.userBookingDetailData.detail.original_price;
          $scope.priceFlag = $scope.finalPrice == $scope.initialPrice ? 0 : 1;
          if ($scope.checkoutData.add_on_service && $scope.checkoutData.add_on_service.length) {
            if ($scope.checkoutData.addon_breakup && $scope.checkoutData.addon_breakup.length) {
              $scope.vendorDetail.Step3.addon_breakup.forEach(function (obj) {
                $scope.checkoutData.add_on_service.forEach(function (extraObj) {
                  if ((extraObj.id == '5' && obj.service_id == '5') || (extraObj.id == '10' && obj.service_id == '10')) {
                    extraObj.count = obj.count;
                  }
                })
              });
            }
          }
          if ((!localStorage.getItem('vendor_logged_in'))) {
            localStorage.setItem("vendor_logged_in", true);
            $state.reload();
          }
        })
        .catch(function (err) {
          console.log(err);
          window.location.href = config.domain;
        });
    }
  }

  $scope.showBreackup = function () {
    $('.cost-est-modal').css('display', 'block');

  }
  $('html').on('click', function (ev) {
    $('.cost-est-modal').css('display', 'none');
  });
  $scope.userBookingDetailFunc();
  $scope.activeInitialPrice = function ($event) {
    var $that = $($event.target);
    $event.stopPropagation();
    /*console.log($event,"event", $that);*/
    $that.hasClass('p-a-a-r') == true ? $that.toggleClass('bgColorGrey') : '';
  }
  var postAccept = function (userDetailId, historyStatus, updateStatus, furtherDiscountValue, extraTextValue, previousPrice) {
    $scope.selectedId = [$scope.userBookingDetailData.detail.user_profile_id, userDetailId, updateStatus, furtherDiscountValue, historyStatus, extraTextValue, 1, previousPrice];
    ngDialog.open({
      template: 'acceptPriceTemplate',
      scope: $scope,
      data: $scope.selectedId,
    })
  }
  $scope.nonZeroPrice = false;
  $scope.postPrice = function (postClass) {
    // if(postClass.max || postClass.min) {
    // 	return false;
    // } else {
    //$('.get-price').css('display','none');

    if ($scope.userBookingDetailData.detail.original_price_numeric == 0 && (!$scope.furtherDiscountValue || $scope.furtherDiscountValue == 0)) {
      $scope.nonZeroPrice = true;
      $timeout(function () {
        $scope.nonZeroPrice = false;
      }, 3000);
      return;
    }
    var historyStatus = $scope.furtherDiscountValue ? 22 : 21;
    var updateStatus = 2;
    var updatePrice = $scope.furtherDiscountValue ? $scope.furtherDiscountValue : $scope.userBookingDetailData.detail.original_price_numeric
    postAccept($scope.userBookingDetailData.detail.id, historyStatus, updateStatus, updatePrice, $scope.extraTextValue);
    /* postAcceptPrice(config.vtoken, $scope.userBookingDetailData.detail.id,historyStatus,updateStatus,updatePrice, $scope.userBookingDetailData.detail.user_profile_id, $scope.extraTextValue).success(function (data) {
    console.log(data,"data");
    $scope.flag = 0;
    $scope.userBookingDetailFunc();
    $('.get-price').css('display','block');
    $('.save-info-loader-new').css('display','none');
    $('#AcceptQuoteModal').modal('hide');
  })*/
    // }
  }

  $scope.updatePrice = function (postClass, updateClass) {
    // if(postClass.max || postClass.min ||  postClass.required) {
    // 	return false;
    if (postClass.required) {
      return false;
    } else {
      //$('.get-price').css('display','none');

      var historyStatus = 23;
      var updateStatus = 2;
      var previousPrice = $scope.userBookingDetailData.detail.price_quote_numeric;
      var updatePrice = $scope.furtherDiscountValue;
      postAccept($scope.userBookingDetailData.detail.id, historyStatus, updateStatus, updatePrice, $scope.extraTextValue, previousPrice);
			/* postAcceptPrice(config.vtoken, $scope.userBookingDetailData.detail.id,historyStatus,updateStatus,updatePrice, $scope.userBookingDetailData.detail.user_profile_id, $scope.extraTextValue).success(function (data) {
			console.log(data,"data");
			$scope.flag = 0;
			$scope.userBookingDetailFunc();
			$('.get-price').css('display','block');
			$('.save-info-loader-new').css('display','none');
			$('#AcceptQuoteModal').modal('hide');
		})*/
    }
  }
  $scope.postReject = function (Details) {
    $scope.selectedId = [Details.user_profile_id, Details.id, 3, '', 31, 0];
    $http({
      method: "GET",
      url: config.domain + "/api/v1/booking/reject_reasons?token=" + vtoken
    })
      .then(function (response) {
        console.log('response', response);
        $scope.reasonList = response.data.data;
      })
      .catch(function (err) {
        console.log('err', err);
      });
    ngDialog.open({
      template: 'reasonTemplateId',
      scope: $scope,
      data: $scope.selectedId,
    });
  }
  $scope.editQuote = function (lastPrice) {
    $scope.furtherDiscountValue = parseInt(lastPrice);
    $('#AcceptQuoteModal').modal('show');
  }
  $scope.rejection = {};
  $scope.sendRequest = function (userProfileId, bookingLeadId, updateStatus, updatePrice, historyStatus, extraTextValue, newloader, previousPrice) {
    console.log($scope.rejection.rejectionId);
    if (newloader == 1) {
      $('.get-price').css('display', 'none');
      $('.save-info-loader-new').css('display', 'block');
    } else {
      $('.save-info-loader').css('display', 'block');
      $('.get-price-new').css('display', 'none');
    }
    console.log('asdf');
    postAcceptPrice(config.vtoken, bookingLeadId, historyStatus, updateStatus, updatePrice, userProfileId, extraTextValue, previousPrice).success(function (data) {
      $scope.flag = 0;
      if (data.response.status == false) {
        ngToast.create({
          content: data.response.message,
          timeout: 4000,
          dismissOnTimeout: true,
          dismissButton: true,
          className: 'warning'
        });
      }
      $scope.userBookingDetailFunc();
      $('.get-price').css('display', 'block');
      $('.get-price-new').css('display', 'block');
      $('.save-info-loader').css('display', 'none');
      $('.save-info-loader-new').css('display', 'none');
      $('#AcceptQuoteModal').modal('hide');
    });
  }

  $scope.sendRequestNew = function (userProfileId, bookingLeadId, updateStatus, updatePrice, historyStatus, extraTextValue, newloader, previousPrice) {
    console.log($scope.rejection.rejectionId);
    if (newloader == 1) {
      $('.get-price').css('display', 'none');
      $('.save-info-loader-new').css('display', 'block');
    } else {
      $('.save-info-loader').css('display', 'block');
      $('.get-price-new').css('display', 'none');
    }
    console.log('asdf');
    if ($scope.rejection.rejectionId) {
      console.log('rejection');
      var d = {
        status: 3,
        booking_lead_vendor_id: bookingLeadId,
        reject_reason_id: $scope.rejection.rejectionId,
      }
    }
    else {
      console.log('price set and update');
      var d = {
        status: 2,
        booking_lead_vendor_id: bookingLeadId,
        vendor_price: updatePrice,
        notes: extraTextValue,
      }
    }
    $http({
      method: "POST",
      url: config.domain + "/api/v2/booking/reply?token=" + vtoken,
      data: d
    })
      .then(function (response) {
        console.log(response);
        $scope.userBookingDetailFunc();
        $('.get-price').css('display', 'block');
        $('.get-price-new').css('display', 'block');
        $('.save-info-loader').css('display', 'none');
        $('.save-info-loader-new').css('display', 'none');
        $('#AcceptQuoteModal').modal('hide');
      })
      .catch(function (err) {
        console.log(err);
      });
  }
}]);


vendorApp.controller('widgetController', ['$scope', '$stateParams', '$state', 'config', '$timeout', 'getInboxMessage', 'postReplyMessage', 'vendorData', function ($scope, $stateParams, $state, config, $timeout, getInboxMessage, postReplyMessage, vendorData) {
  $scope.content = "";
  $scope.ProfileName = $scope.vendorData.name;
  $scope.ReviewCount = $scope.vendorData.reviews_count;
  var pic = $scope.vendorData.vendor_profile_pic_url;
  $scope.picURL = pic.replace("%%", "270");

  function CodeContent(id, profile_link) {
    var str = '<html>' +
      '<head>' +
      '<link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Tangerine">' +
      '<script>' +
      'var getJSON = function(url) {' +
      'return new Promise(function(resolve, reject) {' +
      'var xhr = new XMLHttpRequest();' +
      'xhr.open("get", url, true);' +
      'xhr.responseType = "json";' +
      'xhr.onload = function() {' +
      'var status = xhr.status;' +
      'if (status == 200) {' +
      'resolve(xhr.response);' +
      '}else{' +
      'reject(status);' +
      '}' +
      '};' +
      'xhr.send();' +
      '});' +
      '};' +
      'getJSON("https://www.wedmegood.com/api/v1/vendor/review_widget_detail?version=1.1&vendor_id=' + id + '").then(function(data){' +
      'document.getElementById("profile-name").innerHTML = data.data.vendor_name;' +
      'if(data.data.reviews_count == 1)' +
      'document.getElementById("review-count").innerHTML = data.data.reviews_count + " Review";' +
      'else\n' +
      '\ndocument.getElementById("review-count").innerHTML = data.data.reviews_count + " Reviews";' +
      'var res = data.data.profile_pic_url.replace("%%", "270");' +
      'document.getElementById("img-rep").src = res;' +
      '}, function(status) {' +
      '});' +
      '</script>' +
      '<style>' +
      'p{' +
      'font-family:WedmegoodFont;' +
      'font-style: bold;' +
      '}' +
      '.img-circle{' +
      'border-radius:50%;' +
      'position:absolute;' +
      'z-index: 1;' +
      'height:70px;' +
      'width:70px;' +
      'left:20px;' +
      'top:18px;' +
      '}' +
      '.box{' +
      'position:relative;' +
      'box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);' +
      'height:150px;' +
      'width:300px;' +
      '}' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<a href="' + profile_link + '" target="_newtab">' +
      '<div class="box">' +
      '<img id="img-rep" class="img-circle" src="">' +
      '<p id="profile-name" style = "color:#e72e77;position:absolute;left:110px;font-size:18px"></p>' +
      '<p id="review-count" style = "color:white;position:absolute;left:208px;top:48px;font-size:15px;"></p>' +
      '<img src="https://images.wedmegood.com/images/widget.jpg">' +
      '<p style="position:absolute;font-size:14px;top:152px;left:67px;">View My Profile on WedMegood</p>' +
      '</div>' +
      '</a>' +
      '</body>' +
      '</html>';

    return str;
  }

  function init() {
    $scope.content = CodeContent($scope.vendorData.vendor_id, $scope.vendorData.profile_url);
  }
  init();
  $scope.codeHTML = function () {
    var copyTextarea = document.querySelector('.widgetCode');
    copyTextarea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }
  }
}]);


vendorApp.directive('bookingCard', function ($location, $window, $state, $rootScope) {
  return {
    restrict: 'A',
    templateUrl: '/html/bookingCard.html',
    scope: {
      booking: '=',
      domain: '='
    },
    link: function (scope, element, attrs) {
      scope.bookingData = angular.copy(scope.booking);
      //   console.log(scope.bookingData);
      scope.flag = 0;
      scope.priceFlag = 0;
      scope.S3_URL = 'https://d2eanzqpmoo3ec.cloudfront.net/'
      //scope.incompleted = angular.copy(scope.booking.incomplete);
      //scope.requirement = JSON.parse(scope.requirement);
      var statusText = scope.bookingData.status_text;
      if (statusText.indexOf("|") >= 0) {
        var StatusArray = statusText.split('|');
        scope.status1 = StatusArray[0];
        scope.status2 = StatusArray[1];
        scope.flag = 1;
      }
      scope.finalPrice = scope.bookingData.final_price;
      scope.initialPrice = scope.bookingData.initial_price;
      scope.priceFlag = scope.finalPrice == scope.initialPrice ? 0 : 1;
      scope.getDetail = function (leadId, isNew) {
        window.location.href = scope.domain + '/vendor/feeds/bookingsDetail/' + leadId + '?is_new=' + isNew;
      }
    }
  }
})

vendorApp.controller('statisticsController', ['$scope', '$timeout', '$state', 'viewGraph', 'config', 'vendorData', function ($scope, $timeout, $state, viewGraph, config, vendorData) {
  $scope.filter = 'weekly';
  $scope.statistics = {};
  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  $scope.getGraphInfo = function (filter) {
    $('.graph-filter').css('background-color', 'background-color: rgba(128, 128, 128, 0.11)');
    $('.' + filter).css('background-color', 'white');
    $scope.graphData = [];
    $scope.labels = [];
    $scope.datapoints = [];
    viewGraph(config.vtoken, $scope.vendorId, $scope.filter).success(function (data) {
      $scope.graphInfo = data.data;
      $scope.graphStats = data.total;
      //$scope.graphTotal = data.total;
      for (var key in $scope.graphInfo) {
        if (!isNaN(key)) {
          $scope.graphData.push($scope.graphInfo[key]);
        }
      }
      if ($scope.filter == 'daily') {
        $scope.graphData.sort(function (obj1, obj2) {
          // Ascending: first age less than the previous
          return obj1.day_no - obj2.day_no;
        });
      }
      for (var i = 0; i < $scope.graphData.length; i++) {
        switch ($scope.filter) {
          case 'daily':
            $scope.labels.push($scope.graphData[i].day_name)
            break;
          case 'weekly':
            var date = moment().year(2016).week($scope.graphData[i].week_no);
            var presentdate = date.date()
            var presentmonth = date.format('MMM');
            var nextweek = date.add(1, 'weeks');
            var nextdate = nextweek.date();
            var nextmonth = nextweek.format('MMM')
            var finaldate = presentdate + ' ' + presentmonth + '-' + nextdate + ' ' + nextmonth;
            $scope.labels.push(finaldate);
            break;
          case 'monthly':
            $scope.labels.push($scope.graphData[i].month)
            break;
        }
      }
      if ($scope.filter != 'daily') {
        $scope.labels.reverse();
        $scope.graphData.reverse();
      }
      $scope.series = ["dummy"];
      for (var i = 0; i < $scope.graphData.length; i++) {
        $scope.datapoints.push(Number($scope.graphData[i].total));
      }
      $scope.datapointsCont = [$scope.datapoints];
    })
  }
  $scope.getGraphInfo($scope.filter);
  $scope.changeGraphFilter = function (filter) {
    $scope.filter = filter;
    $scope.getGraphInfo($scope.filter);
  }
  // viewGraph(config.vtoken, $scope.vendorId, $scope.filter).success(function(data) {
  //   $scope.statistics.vGdata = data.data;
  //   //$scope.statistics.vGTotal = data.total
  // })
}]);

vendorApp.directive('vurl', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$validators.urlVald = function (value) {
        return validateUrl(value);
      }
    }
  }
})



vendorApp.directive('minmax', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      modelvalue: '=',
      limitvalue: '@',
      model: '=',
    },
    link: function (scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$validators.minMax = function (value) {
        return ((value >= attrs.min) && (value <= attrs.max));
      }
      $(element).blur(function () {
        if (isNaN(scope.modelvalue) || typeof scope.modelvalue == 'undefined') {
          scope.$apply(function () {
            scope.modelvalue = Number(scope.limitvalue);
          })
        }

      })
    }
  }
})

vendorApp.controller('pricingController', ['$scope', '$state', 'config', 'getVendorServices', 'postPriceService', 'vendorData', '$timeout', function ($scope, $state, config, getVendorServices, postPriceService, vendorData, $timeout) {
  //console.log("pricingController");
  $scope.vendorData = vendorData.data.data;
  $scope.vendorCategoryId = vendorData.data.data.category_id;
  //console.log("$scope.vendorData", $scope.vendorData);
  $scope.vendorServices = {};
  $scope.selection = {};
  $scope.S3_URL = config.S3_URL;
  $scope.selection.ids = {};
  $scope.fullDayCost = [];
  $scope.peopleNeeded = [];
  $scope.halfpeopleNeeded = [];
  $scope.halfDayCost = [];
  $scope.AddOnPrice = [];
  $scope.freebiePercentageVal = [];
  $scope.discountPercentage = [];
  $scope.discount;
  $scope.extrachargeOption;
  $scope.extrachargePrice;
  $scope.freebieApplicable;
  $scope.freebieLimit;
  $scope.makeupExtraId = 0;
  $scope.checkboxModel = {
    value1: false,
  };
  $scope.muaTrial = {
    name: '',
    adjustable: false,
    available: false,
    charges: '',
    discount: 0
  };

  $scope.getPriceServices = {};
  $scope.getdiscountServices = {};
  $scope.getVenuePayment = {};
  $scope.vendorPaymentSchedule = {}
  $scope.vendorPaymentSchedule.discountSchedule = {}
  var d = new Date();
  var currentYear = d.getFullYear();
  var currentMonth = d.getMonth();
  $scope.arryOfYear = [];

  if (vendorData.data.data.role[0] == 'ROLE_BRAND_VENDOR') {
    $timeout(function () {
      $state.go('main.leads', { 'id': $scope.vendorId }, { reload: false });
    });
  }
  for (var i = 0; i < 12; i++) {
    $scope.arryOfYear[i] = {};
    $scope.arryOfYear[i].month = d.getMonth();
    $scope.arryOfYear[i].year = d.getFullYear();
    d.setMonth(d.getMonth() + 1, 1);
  }
  $scope.checkService = function () {
  }
  $('form').on('focus', 'input[type=number]', function (e) {
    $(this).on('mousewheel.disableScroll', function (e) {
      e.preventDefault()
    })
  })
  $('form').on('blur', 'input[type=number]', function (e) {
    $(this).off('mousewheel.disableScroll')
  })
  $scope.vendorPaymentSchedule.advance = true;
  var getVendorServicesFunction = function () {
    getVendorServices(config.vtoken, $scope.vendorCategoryId).success(function (data) {
      $scope.functionList = data.data.function_list;
      $scope.freebieApplicable = data.data.freebie_applicable;
      $scope.freebieLimit = data.data.freebie_limit
      $scope.functionList.typeOne = [];
      $scope.functionList.typeTwo = [];
      $scope.vendorServices = data.data.category_services;
      $scope.vendorPaymentSchedule.discountSchedule.advance = data.data.min_advance_discount_percentage;
      $scope.vendorPaymentSchedule.discountSchedule.advancePay = data.data.advance_payment_days;
      $scope.discount = data.data.discount_applicable;
      $scope.checkboxModel.value1 = data.data.outstation_applicable;
      $scope.vendorServices.mainServices = [];
      $scope.vendorServices.packageServices = [];
      $scope.vendorServices.addOnServices = [];
      $scope.hasServiceTypeThree = false;
      $scope.vendorServices.forEach(function (obj) {
        if (obj.service_type == 1) {
          $scope.vendorServices.mainServices.push(obj);
        }
        else if (obj.service_type == 3) {
          $scope.hasServiceTypeThree = true;
          $scope.vendorServices.packageServices.push(obj);
        }
        else {
          $scope.vendorServices.addOnServices.push(obj);
        }
      });
      $scope.functionList.forEach(function (obj) {
        if (obj.type == 1) {
          $scope.functionList.typeOne.push(obj.name);
        } else {
          $scope.functionList.typeTwo.push(obj.name);
        }
      });
      $scope.marriageDayFun = $scope.functionList.typeOne.toString();
      $scope.otherDayFun = $scope.functionList.typeTwo.toString();
      if (data.data.discount_details) {
        $scope.getdiscountServices = data.data.discount_details;
        $scope.discount = data.data.discount_applicable;
        data.data.discount_details.forEach(function (obj) {

          var month = parseInt(obj.month);
          var per = parseInt(obj.discount_percentage);
          $scope.discountPercentage[month - 1] = per;
        })
      };
      if (data.data.vendor_payment_schedule.length) {
        $scope.getVenuePayment = data.data.vendor_payment_schedule
        if (data.data.vendor_payment_schedule[0].advance) {
          $scope.vendorPaymentSchedule.advance = true;
          $scope.vendorPaymentSchedule.discountSchedule.advance = parseInt(data.data.vendor_payment_schedule[0].advance);
        };
        if (data.data.vendor_payment_schedule[0].post_event != 0 && data.data.vendor_payment_schedule[0].post_event != null) {
          $scope.vendorPaymentSchedule.postEvent = true;
          $scope.vendorPaymentSchedule.discountSchedule.postEventPay = parseInt(data.data.vendor_payment_schedule[0].pay_term_post_days);
          $scope.vendorPaymentSchedule.discountSchedule.postEvent = parseInt(data.data.vendor_payment_schedule[0].post_event);
        };
        if (data.data.vendor_payment_schedule[0].pre_event != 0 && data.data.vendor_payment_schedule[0].pre_event != null) {
          $scope.vendorPaymentSchedule.preEvent = true;
          $scope.vendorPaymentSchedule.discountSchedule.preEvent = parseInt(data.data.vendor_payment_schedule[0].pre_event);
          $scope.vendorPaymentSchedule.discountSchedule.preEventPay = parseInt(data.data.vendor_payment_schedule[0].pay_term_pre_days);
        };
      };
      if (data.data.pricing_details) {
        $scope.getPriceServices = data.data.pricing_details;
        data.data.pricing_details.forEach(function (obj) {
          var serviceTypeId = obj.service_type_id;
          $scope.selection.ids[serviceTypeId] = true;
          if (obj.pricing_type == 1) {
            $scope.fullDayCost[obj.service_type_id] = parseInt(obj.service_price);
            $scope.vendorCategoryId == 1 ? $scope.peopleNeeded[obj.service_type_id] = parseInt(obj.no_of_pax) : $scope.peopleNeeded[obj.service_type_id] = parseInt(obj.outstation_service_price);
          } else if (obj.pricing_type == 2) {
            $scope.halfDayCost[obj.service_type_id] = parseInt(obj.service_price);
            $scope.vendorCategoryId == 1 ? $scope.halfpeopleNeeded[obj.service_type_id] = parseInt(obj.no_of_pax) : $scope.halfpeopleNeeded[obj.service_type_id] = parseInt(obj.outstation_service_price);
          } else {
            $scope.AddOnPrice[obj.service_type_id] = parseInt(obj.service_price);
            console.log($scope.AddOnPrice[obj.service_type_id]);
            $scope.freebiePercentageVal[obj.service_type_id] = obj.freebie_percentage == null ? '0%' : obj.freebie_percentage;
          }
        })
      }
      if (data.data.mua_pricing) {
        $scope.extrachargeOption = data.data.mua_pricing.serve_outside_studio;
        $scope.extrachargePrice = data.data.mua_pricing.outside_studio_charges_per_function;
        $scope.makeupExtraId = data.data.mua_pricing.mua_pricing_id;
        $scope.muaTrial.available = data.data.mua_pricing.trial_available;
        $scope.muaTrial.adjustable = data.data.mua_pricing.trail_adjustable;
        $scope.muaTrial.charges = data.data.mua_pricing.trial_charges;
        $scope.muaTrial.discount = data.data.mua_pricing.trial_discount;
        $scope.muaTrial.name = data.data.mua_pricing.trial_charges != 0 ? 'paid' : 'free';
      }
    });
  }
  getVendorServicesFunction();

  $scope.freebiePercentage = function (event, id) {
    $scope.freebiePercentageVal[id] = $(event.target).text();
  }
  $scope.trialdiscount = function (event) {
    $scope.muaTrial.discount = $(event.target).text();
  }
  $scope.removeError = function (id) {
    $("#" + id).hasClass('costRequirep') == true ? $("#" + id).removeClass('costRequirep') : "";
    $("#" + id).hasClass('costRequireph') == true ? $("#" + id).removeClass('costRequireph') : "";
    $("#" + id).hasClass('costRequire') == true ? $("#" + id).removeClass('costRequire') : "";
    $("#required-error").removeClass('required-error-class');
    $("#status-false").removeClass('required-error-class');
  }
  $scope.mainServiceValue = function () {
    var dif = [];
    var keyLength = 0;
    var falseLength = 0;
    for (var key in $scope.selection.ids) {
      keyLength++;
      if ($scope.selection.ids[key] == false) {
        falseLength++;
      }
    }
    if (keyLength == falseLength) {
      $scope.errorMessage = 'Atleast one service is required'
      $("#status-false").addClass('required-error-class');
      return false;
    }
    function differences(fullDayCost, halfDayCost) {

      for (key in $scope.fullDayCost) { //In a and not in b
        if (!$scope.halfDayCost[key] && $scope.selection.ids[key]) {
          dif.push(key);
        }
      }
      for (key in $scope.halfDayCost) { //in b and not in a
        if (!$scope.fullDayCost[key] && $scope.selection.ids[key]) {
          dif.push(key);
        }
      }
      return dif;
    }
    if ($scope.vendorCategoryId == 3) {
      differences($scope.fullDayCost, $scope.halfDayCost);

    }

    if (dif.length) {
      for (var i = 0; i < dif.length; i++) {
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        if (!$scope.fullDayCost[dif[i]]) {
          $("#people" + dif[i]).addClass('costRequire');
        } else {
          $("#halfpeople" + dif[i]).addClass('costRequire');

        }
        $("#required-error").addClass('required-error-class');
        data = {};
      }
      return false;
    }

    //$("#successSiteModal").modal('show');
    if (($scope.fullDayCost && $scope.vendorCategoryId == 1) || ($scope.vendorCategoryId == 3 && $scope.fullDayCost && $scope.checkboxModel.value1)) {
      for (var key in $scope.fullDayCost) {
        if ($scope.fullDayCost[key] && ($scope.peopleNeeded[key] == undefined || $scope.peopleNeeded[key] == null || isNaN($scope.peopleNeeded[key])) && $scope.selection.ids[key] == true) {
          $("#fullpeople" + key).addClass('costRequirep');
          $("#required-error").addClass('required-error-class');
          return false;
        } else {
          $("#fullpeople" + key).removeClass('costRequirep');
          $("#required-error").removeClass('required-error-class');
        }
      }
    }
    if (($scope.halfDayCost && $scope.vendorCategoryId == 1) || ($scope.halfDayCost && $scope.vendorCategoryId == 3 && $scope.checkboxModel.value1)) {
      for (var key in $scope.halfDayCost) {
        if ($scope.halfDayCost[key] && ($scope.halfpeopleNeeded[key] == undefined || $scope.halfpeopleNeeded[key] == null || isNaN($scope.halfpeopleNeeded[key])) && $scope.selection.ids[key] == true) {
          $("#halffullpeople" + key).addClass('costRequireph');
          $("#required-error").addClass('required-error-class');
          return false;
        } else {
          $("#halffullpeople" + key).removeClass('costRequireph');
          $("#required-error").removeClass('required-error-class');
        }
      }
    }
    //console.log($scope.vendorPaymentSchedule.discountSchedule.advance , $scope.vendorPaymentSchedule.discountSchedule.postEvent , $scope.vendorPaymentSchedule.discountSchedule.preEvent, $scope.vendorPaymentSchedule)
    var advanceValue = ($scope.vendorPaymentSchedule.discountSchedule.advance == undefined || $scope.vendorPaymentSchedule.advance == false) ? 0 : $scope.vendorPaymentSchedule.discountSchedule.advance;
    var postEventValue = ($scope.vendorPaymentSchedule.discountSchedule.postEvent == undefined || $scope.vendorPaymentSchedule.postEvent == false) ? 0 : $scope.vendorPaymentSchedule.discountSchedule.postEvent;
    var preEventValue = ($scope.vendorPaymentSchedule.discountSchedule.preEvent == undefined || $scope.vendorPaymentSchedule.preEvent == false) ? 0 : $scope.vendorPaymentSchedule.discountSchedule.preEvent;
    var totalValue = advanceValue + postEventValue + preEventValue;
    if (totalValue != 100) {
      $('.payment-schedule').css('display', 'inline');
      return false;
    } else {
      $('.payment-schedule').css('display', 'none');
    }
    $('.save-info-loader').css('display', 'block');
    $('.white-text').css('display', 'none');
    var data = {};
    data.freebie_applicable = $scope.freebieApplicable;
    if ($scope.freebieApplicable == true) {
      if ($scope.freebieLimit == null) {
        data = {};
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#freebies-charge-cost-err").addClass('costRequire');
        $("#required-error").addClass('required-error-class');
        return
      } else {
        $('.save-info-loader').css('display', 'block');
        $('.white-text').css('display', 'none');
        $("#freebies-charge-cost-err").removeClass('costRequire');
        $("#required-error").removeClass('required-error-class');
        data.freebie_limit = $scope.freebieLimit;
      }

    }
    console.log(data);
    data.services = [];
    var i = 0;
    for (var key in $scope.selection.ids) {
      if ($scope.selection.ids[key] == false && $scope.fullDayCost) {
        for (var dfkey in $scope.fullDayCost) {
          if (dfkey == key) {
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == dfkey && obj.pricing_type == 1) {
                  data.services[i] = {};
                  data.services[i].pricing_id = obj.id;
                  data.services[i].status = 0;
                  data.services[i].pricing_type = 1;
                  i++;
                }
              });
            }
          }
        }
      }
      if ($scope.selection.ids[key] == false && $scope.halfDayCost) {
        for (var dhkey in $scope.halfDayCost) {
          if (dhkey == key) {
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == dhkey && obj.pricing_type == 2) {
                  data.services[i] = {};
                  data.services[i].pricing_id = obj.id;
                  data.services[i].status = 0;
                  data.services[i].pricing_type = 2;
                  i++;
                }
              });
            }
          }
        }
      }
      if ($scope.selection.ids[key] == false && $scope.AddOnPrice) {
        for (var dakey in $scope.AddOnPrice) {
          if (dakey == key) {
            data.services[i] = {};
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == dakey && obj.pricing_type == null) {
                  data.services[i].pricing_id = obj.id;
                  data.services[i].status = 0;
                  i++;
                }
              });
            }
          }
        }
      }
      if ($scope.selection.ids[key] == true && $scope.fullDayCost) {
        for (var fkey in $scope.fullDayCost) {
          if (fkey == key) {
            data.services[i] = {}
            data.services[i].service_type_id = fkey;
            data.services[i].service_price = $scope.fullDayCost[fkey];
            data.services[i].pricing_type = 1;
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == fkey && obj.pricing_type == 1 && $scope.fullDayCost[fkey] != null) {
                  data.services[i].pricing_id = obj.id;
                } else if (obj.service_type_id == fkey && obj.pricing_type == 1 && $scope.fullDayCost[fkey] == null) {
                  data.services[i].pricing_id = obj.id;
                  data.services[i].status = 0;
                  delete data.services[i].service_price;
                  delete data.services[i].service_type_id;
                  i++;
                }
              });
            } else if ($scope.fullDayCost[fkey] == null) {
              delete data.services[i];
            }
          }
        }
        for (var pkey in $scope.peopleNeeded) {
          if (pkey == key && $scope.peopleNeeded[pkey] != null) {
            if (data.services[i] == undefined) {
              $('.save-info-loader').css('display', 'none');
              $('.white-text').css('display', 'block');
              $("#people" + pkey).addClass('costRequire');
              $("#required-error").addClass('required-error-class');
              data = {};
              return;
            } else {
              $('.save-info-loader').css('display', 'block');
              $('.white-text').css('display', 'none');
              $("#people" + pkey).removeClass('costRequire');
              $("#required-error").removeClass('required-error-class');
            }
            $scope.vendorCategoryId == 1 ? data.services[i].no_of_pax = $scope.peopleNeeded[pkey] : ($scope.checkboxModel.value1 ? data.services[i].outstation_service_price = $scope.peopleNeeded[pkey] : data.services[i].outstation_service_price = null);
            //$scope.vendorCategoryId == 3 ? data.services[i].outstation_service_price = $scope.peopleNeeded[pkey];
            i++;
          } else if (pkey == key && $scope.peopleNeeded[pkey] == null && $scope.vendorCategoryId == 3 && $scope.fullDayCost[pkey] != null) {
            //data.services[i].no_of_pax = $scope.peopleNeeded[pkey];
            i++
          }
        }
        $scope.vendorCategoryId == 3 ? i++ : "";
      }
      if ($scope.selection.ids[key] == true && $scope.halfDayCost) {
        for (var hkey in $scope.halfDayCost) {
          if (hkey == key) {
            data.services[i] = {}
            data.services[i].service_type_id = hkey;
            data.services[i].service_price = $scope.halfDayCost[hkey];
            data.services[i].pricing_type = 2;
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == hkey && obj.pricing_type == 2 && $scope.halfDayCost[hkey] != null) {
                  data.services[i].pricing_id = obj.id;
                } else if (obj.service_type_id == hkey && obj.pricing_type == 2 && $scope.halfDayCost[hkey] == null) {
                  data.services[i].pricing_id = obj.id;
                  data.services[i].status = 0;
                  delete data.services[i].service_price;
                  delete data.services[i].service_type_id;
                  i++;
                }
              });
            } else if ($scope.halfDayCost[hkey] == null) {
              delete data.services[i];
            }
          }
        }
        for (var hpkey in $scope.halfpeopleNeeded) {
          if (hpkey == key && $scope.halfpeopleNeeded[hpkey] != null) {
            if (data.services[i] == undefined) {
              $('.save-info-loader').css('display', 'none');
              $('.white-text').css('display', 'block');
              $("#halfpeople" + hpkey).addClass('costRequire');
              $("#required-error").addClass('required-error-class');
              data = {};
              return;
            } else {
              $('.save-info-loader').css('display', 'block');
              $('.white-text').css('display', 'none');
              $("#halfpeople" + hpkey).removeClass('costRequire');
              $("#required-error").removeClass('required-error-class');
            }
            //data.services[i].no_of_pax = $scope.halfpeopleNeeded[hpkey];
            $scope.vendorCategoryId == 1 ? data.services[i].no_of_pax = $scope.halfpeopleNeeded[hpkey] : ($scope.checkboxModel.value1 ? data.services[i].outstation_service_price = $scope.halfpeopleNeeded[hpkey] : data.services[i].outstation_service_price = null);
            i++
          } else if (hpkey == key && $scope.halfpeopleNeeded[hpkey] == null && $scope.vendorCategoryId == 3 && $scope.halfDayCost[hpkey] != null) {
            //data.services[i].no_of_pax = $scope.halfpeopleNeeded[hpkey];
            i++;
          }
        }
        $scope.vendorCategoryId == 3 ? i++ : "";
      }
      if ($scope.selection.ids[key] == true && $scope.AddOnPrice) {
        for (var Akey in $scope.AddOnPrice) {
          if (Akey == key) {
            data.services[i] = {};
            data.services[i].service_type_id = Akey;
            data.services[i].service_price = $scope.AddOnPrice[Akey];
            data.services[i].freebie_percentage = $scope.freebiePercentageVal[Akey] != undefined ? $scope.freebiePercentageVal[Akey].replace('%', '') : 0;
            if ($scope.getPriceServices.length) {
              $scope.getPriceServices.forEach(function (obj) {
                if (obj.service_type_id == Akey && obj.pricing_type == null && $scope.AddOnPrice[Akey] != null) {
                  data.services[i].pricing_id = obj.id;
                } else if (obj.service_type_id == Akey && obj.pricing_type == null && $scope.AddOnPrice[Akey] == null) {
                  if (typeof data.services[i] !== 'undefined') {
                    data.services[i].pricing_id = obj.id;
                    data.services[i].status = 0;
                    delete data.services[i].service_price;
                    delete data.services[i].service_type_id;
                  }
                } else if ($scope.AddOnPrice[Akey] == null) {
                  delete data.services[i];
                }
              });
            } else if ($scope.AddOnPrice[Akey] == null) {
              delete data.services[i];
            }
            i++;
          }
        }
      }
    }
    if ($scope.discount) {
      data.discount_applicable = 1;
      data.monthwise_discount = {};
      for (var dkey in $scope.discountPercentage) {
        if ($scope.discountPercentage.hasOwnProperty(dkey)) {
          var Intdkey = parseInt(dkey);
          var finalDkey = Intdkey + 1;
          data.monthwise_discount[finalDkey] = {};
          $scope.discountPercentage[dkey] = $scope.discountPercentage[dkey] == null ? 0 : $scope.discountPercentage[dkey];
          data.monthwise_discount[finalDkey].percentage = $scope.discountPercentage[dkey];
          $scope.arryOfYear.forEach(function (obj) {
            var finalMonth = parseInt(obj.month)
            if ((finalMonth + 1) == finalDkey) {
              data.monthwise_discount[finalDkey].year = obj.year;
            }
          })
          if ($scope.getdiscountServices.length) {
            $scope.getdiscountServices.forEach(function (obj) {
              if (obj.month == finalDkey) {
                data.monthwise_discount[finalDkey].discount_id = obj.id;
              }
            })
          }
        }
      }
    } else {
      data.discount_applicable = 0;
    }
    if ($scope.checkboxModel.value1) {
      data.outstation_applicable = 1;
    } else {
      data.outstation_applicable = 0;
    }
    if ($scope.vendorPaymentSchedule.discountSchedule.advance || $scope.vendorPaymentSchedule.discountSchedule.postEvent || $scope.vendorPaymentSchedule.discountSchedule.preEvent) {
      data.vendor_payment_schedule = {}
      if (advanceValue != 0) {
        data.vendor_payment_schedule.advance = advanceValue;
        data.vendor_payment_schedule.pay_term_advance_days = 10;
        $("#advanceError").removeClass('costRequirep');
        $("#required-error").removeClass('required-error-class');
      } else if (advanceValue == 0) {
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#advanceError").addClass('costRequirep');
        $("#required-error").addClass('required-error-class');
        data = {};
        return false;
      }
      if (postEventValue && ($scope.vendorPaymentSchedule.discountSchedule.postEventPay || $scope.vendorPaymentSchedule.discountSchedule.postEventPay == 0) && $scope.vendorPaymentSchedule.postEvent == true) {
        data.vendor_payment_schedule.post_event = postEventValue;
        data.vendor_payment_schedule.pay_term_post_days = $scope.vendorPaymentSchedule.discountSchedule.postEventPay;
        $("#postError").removeClass('costRequirep');
        $("#required-error").removeClass('required-error-class');
      } else if (postEventValue == 0 && ($scope.vendorPaymentSchedule.discountSchedule.postEventPay || $scope.vendorPaymentSchedule.discountSchedule.postEventPay == 0) && $scope.vendorPaymentSchedule.postEvent == true) {
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#postError").addClass('costRequirep');
        $("#required-error").addClass('required-error-class');
        data = {};
        return false;
      } else if ($scope.vendorPaymentSchedule.postEvent == false) {
        data.vendor_payment_schedule.post_event = 0;
        data.vendor_payment_schedule.pay_term_post_days = 0;
      } else if ($scope.vendorPaymentSchedule.discountSchedule.postEventPay == null && $scope.vendorPaymentSchedule.postEvent == true) {
        data.vendor_payment_schedule.post_event = postEventValue;
        data.vendor_payment_schedule.pay_term_post_days = 0;
      }
      if (preEventValue && ($scope.vendorPaymentSchedule.discountSchedule.preEventPay || $scope.vendorPaymentSchedule.discountSchedule.preEventPay == 0) && $scope.vendorPaymentSchedule.preEvent == true) {
        data.vendor_payment_schedule.pre_event = preEventValue;
        data.vendor_payment_schedule.pay_term_pre_days = $scope.vendorPaymentSchedule.discountSchedule.preEventPay;
        $("#preError").removeClass('costRequirep');
        $("#required-error").removeClass('required-error-class');
      } else if (preEventValue == 0 && ($scope.vendorPaymentSchedule.discountSchedule.preEventPay || $scope.vendorPaymentSchedule.discountSchedule.preEventPay == 0) && $scope.vendorPaymentSchedule.preEvent == true) {
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#preError").addClass('costRequirep');
        $("#required-error").addClass('required-error-class');
        data = {};
      } else if ($scope.vendorPaymentSchedule.preEvent == false) {
        data.vendor_payment_schedule.pre_event = 0;
        data.vendor_payment_schedule.pay_term_pre_days = 0;
      } else if ($scope.vendorPaymentSchedule.discountSchedule.preEventPay == null && $scope.vendorPaymentSchedule.preEvent == true) {
        data.vendor_payment_schedule.pre_event = preEventValue;
        data.vendor_payment_schedule.pay_term_pre_days = 0;
      }
      if ($scope.getVenuePayment.length) {
        data.vendor_payment_schedule.schedule_id = $scope.getVenuePayment[0].id;
      }
    }
    if ($scope.extrachargeOption && $scope.extrachargeOption != undefined) {
      data.mua_pricing = {
        'serve_outside_studio': $scope.extrachargeOption,
        'outside_studio_charges_per_function': $scope.extrachargePrice
      }
      if ($scope.makeupExtraId) {
        data.mua_pricing.mua_pricing_id = $scope.makeupExtraId;
      }
    } else if ($scope.makeupExtraId) {
      data.mua_pricing = {
        'mua_pricing_id': $scope.makeupExtraId,
        'serve_outside_studio': false
      }
    }
    var addMuaPricing = function () {
      if ($scope.muaTrial.available == true) {
        data.mua_pricing.trial_available = $scope.muaTrial.available;
        if ($scope.muaTrial.name == 'free') {
          data.mua_pricing.trail_adjustable = false;
          data.mua_pricing.trial_charges = 0;
          data.mua_pricing.trial_discount = 0;
        } else if ($scope.muaTrial.name == 'paid') {
          data.mua_pricing.trail_adjustable = $scope.muaTrial.adjustable;
          data.mua_pricing.trial_charges = $scope.muaTrial.charges;
          data.mua_pricing.trial_discount = $scope.muaTrial.discount;
        }
      } else {
        // data.mua_pricing.trial_available = false;
        // data.mua_pricing.trail_adjustable = false;
        // data.mua_pricing.trial_charges = 0;
        // data.mua_pricing.trial_discount = 0;
      }
    }

    if (data.mua_pricing) {
      addMuaPricing();
    } else {
      data.mua_pricing = {};
      if ($scope.makeupExtraId) {
        data.mua_pricing.mua_pricing_id = $scope.makeupExtraId;
      }
      addMuaPricing();
    }

    Array.prototype.clean = function (deleteValue) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] == deleteValue) {
          this.splice(i, 1);
          i--;
        }
      }
      return this;
    };

    data.services.clean(undefined);

    var package_cnt = 0;
    var package_flag = 0;
    for (var i in $scope.vendorServices.packageServices) {
      // console.log($scope.AddOnPrice[$scope.vendorServices.packageServices[i].id]);
      if ($scope.selection.ids[$scope.vendorServices.packageServices[i].id] == true && (typeof $scope.AddOnPrice[$scope.vendorServices.packageServices[i].id] == 'undefined' || $scope.AddOnPrice[$scope.vendorServices.packageServices[i].id] == null)) {
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#required-error").addClass('required-error-class');
        $("#package" + $scope.vendorServices.packageServices[i].id).addClass('costRequire');
        package_flag = 1;
      }
      if (package_cnt == $scope.vendorServices.packageServices.length && package_flag == 1) {
        return;
      }
      package_cnt++;
    }

    var addOn_cnt = 0;
    var addOn_flag = 0;
    for (var i in $scope.vendorServices.addOnServices) {
      console.log(addOn_cnt, i, $scope.vendorServices.addOnServices.length);
      // console.log($scope.AddOnPrice[$scope.vendorServices.addOnServices[i].id]);
      if ($scope.selection.ids[$scope.vendorServices.addOnServices[i].id] == true && (typeof $scope.AddOnPrice[$scope.vendorServices.addOnServices[i].id] == 'undefined' || $scope.AddOnPrice[$scope.vendorServices.addOnServices[i].id] == null)) {
        console.log('here test');
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#required-error").addClass('required-error-class');
        $("#addOnService" + $scope.vendorServices.addOnServices[i].id).addClass('addOnServices-costRequire');
        addOn_flag = 1;
      }
      if (addOn_cnt == $scope.vendorServices.addOnServices.length && addOn_flag == 1) {
        return;
      }
      addOn_cnt++;
    }

    postPriceService(config.vtoken, data).success(function (data) {
      if (data.response.status == true) {
        $("#successSiteModal").modal('show');
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#status-false").removeClass('required-error-class');
        getVendorServicesFunction();
        setTimeout(function () {
          $("#successSiteModal").modal('hide');
          $('#pricing').click();
        }, 1000);
      } else if (data.response.status == false) {
        $scope.errorMessage = data.response.message;
        $('.save-info-loader').css('display', 'none');
        $('.white-text').css('display', 'block');
        $("#status-false").text($scope.errorMessage);
        $("#status-false").addClass('required-error-class');
      }

    });
  };

  $scope.changeEvt = function (id) {
    console.log('test');
    $("#package" + id).removeClass('costRequire');
    $("#required-error").removeClass('required-error-class');
  }
  $scope.changeEvtAddOn = function (id) {
    console.log('test here');
    $("#addOnService" + id).removeClass('addOnServices-costRequire');
    $("#required-error").removeClass('required-error-class');
  }

}]);
vendorApp.directive('eatClickIf', ['$parse', '$rootScope',
  function ($parse, $rootScope) {
    return {
      // this ensure eatClickIf be compiled before ngClick
      priority: 100,
      restrict: 'A',
      // controller: function(scope,element,attrs) {
      //   scope.showChangePrompt = function() {
      //     console.log('show Changes');
      //   }
      // },
      compile: function ($element, attr) {
        var fn = $parse(attr.eatClickIf);
        return {
          pre: function link(scope, element) {
            var eventName = 'click';
            element.on(eventName, function (event) {
              var callback = function () {
                if (fn(scope, { $event: event })) {
                  // prevents ng-click to be executed
                  event.stopImmediatePropagation();
                  // prevents href
                  event.preventDefault();
                  scope.showChangePrompt(attr.uiSref);
                  return false;
                }
              };
              if ($rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          },
          post: function () { }
        }
      }
    }
  }
]);

angular.bootstrap(document.getElementById("vendorFeed"), ['vendorApp']);

